import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { routes } from "../../helper/routes";
import _ from "lodash";
import SelfGradeModal from "../../components/common/modal/SelfGradeModal";
import ModalHeader from "../../components/common/modal/ModalHeader";
import ModalBody from "../../components/common/modal/ModalBody";
import { questionMCQAnswerTypeConstants, questionTypeConstants } from "../../helper/constants";
import { AzureStorage } from "../../helper/azureStorage";
import config from "../../helper/config";
import APIHandler from "../../handlers/APIHandler";
import AdminTemplate from "../../components/admin/layouts/Template";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import Spinner from "../../components/common/Spinner";
import Card from "../../components/common/Card";
import CardHeader from "../../components/common/CardHeader";
import CardBody from "../../components/common/CardBody";
import CardTitle from "../../components/common/AssessmentCardTitle";
import CardToolbar from '../../components/common/QuestionCardToolBar.js';
import Breadcrumb from "../../components/common/Breadcrumb";
import BreadcrumbItem from "../../components/common/BreadcrumbItem";
import Button from "../../components/common/form/Button";
import CheckBox from "../../components/common/form/CheckBox";
import CheckBoxInline from "../../components/common/form/CheckBoxInline";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Marks from "../../components/common/tabs/Marks";
import { convertFromRaw, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import ViewEditor from "../../components/common/editor/ViewEditor";
import { questionActions } from "../../actions/assessment/questionActions";
import { assessmentActions } from "../../actions/assessment/assessmentActions";
import { messageTypes } from "../../reducers/types";
import { staffUserActions } from "../../actions/user_management/staffUserActions.js";
import { manageUserActions } from "../../actions/user_management/manageUserActions.js";
import { libraryActions } from "../../actions/question/libraryActions";
import { createActions as questionCreateActions } from "../../actions/question/createActions";
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import { customerConstants } from "../../helper/constants.js";
import ReactSpinner from "react-bootstrap/Spinner";
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '../../components/common/form/FormGroup.js';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Form from "react-bootstrap/Form";
import { ASSESSMENT_QUESTION_FILTERS } from '../../helper/constants.js';
import { CMC_ASSESSMENT_QUESTION_FILTERS } from '../../helper/constants.js';
import TabContent from '../../components/common/tabs/TabContent.js';
import TabPane from '../../components/common/tabs/TabPane.js';
import MaterialCustomTablePagination from "../../components/common/MaterialCustomTablePagination.js";
import { candidateService } from "../../service/settings/candidate/candidateService.js";
import RadioInline from '../../components/common/form/RadioInline.js';
import Radio from '../../components/common/form/Radio.js';
import moment from "moment";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import { Alert, Backdrop, Box, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Fab, IconButton, InputLabel, LinearProgress, MenuItem, Modal, Select, SpeedDialAction, SpeedDialIcon, Typography } from "@mui/material";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FormControlLabel from "@mui/material/FormControlLabel";
import PaperListChips from "../manage/paper/edsider/FindPaperTabs/PaperListChips.js";
import { createService } from "../../service/question/createService.js";
import ReactForm from "react-bootstrap/Form";
import ClearIcon from '@mui/icons-material/Clear';
import Tooltip from "@mui/material/Tooltip";
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import SpeedDial from '@mui/material/SpeedDial'
import { assessmentService } from "../../service/assessment/assessmentService.js";
import AddIcon from '@mui/icons-material/Add';
import ConfirmationDialog from '../../components/common/dialog/ConfirmationDialog.js';
import DataHandler from "../../handlers/DataHandler.js";
import Snackbar from '@mui/material/Snackbar';
import AddQuestionPartSection from "./AddQuestionPartSection.js";
import EditIcon from '@mui/icons-material/Edit';
import ChevronLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import PaperFilterLayout from "../manage/paper/edsider/TheFilter/PaperFilterLayout.js";
import { EMPLOYEE_FILTERS } from '../../helper/constants.js'
import { select } from "underscore";
import "./SetupAssessment.css";
import { withRouter } from "react-router-dom";

const getCustomerFeatureFlag = () => {
	return config.customerConfigs.featureFlag;
};

let cancelClass, confirmClass, isCMC, gradeText, FILTERS
const customer = getCustomerFeatureFlag()
switch (customer) {
	case customerConstants.EXO_CUSTOMER1:
		isCMC = false;
		gradeText = "Grade";
		FILTERS = ASSESSMENT_QUESTION_FILTERS
		cancelClass = "btn-default"
		confirmClass = "btn-primary"
		break
	case customerConstants.EXO_CUSTOMER2:
		isCMC = true;
		gradeText = "Year";
		FILTERS = CMC_ASSESSMENT_QUESTION_FILTERS
		cancelClass = "cmc-btn-default"
		confirmClass = "cmc-btn-primary"
		break
	default:
		isCMC = false;
		gradeText = "Grade";
		FILTERS = ASSESSMENT_QUESTION_FILTERS
		cancelClass = "btn-default"
		confirmClass = "btn-primary"
		break
}


const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	border: '2px solid #000',
	boxShadow: 24,
	p: 4,
};


class Finalize extends React.Component {
	constructor(props) {
		super(props);

		this.ref_tagify = React.createRef();
		this.state = {
			assessment_title: "",
			auto_shuffle: false,
			assessmentQuestionsData: [],
			assessmentAllQuestionsData: [],
			questions_contents_by_type: {},
			print_questions: [],
			to_delete: [],
			total: "",
			errors: {},
			mark_allocation: {},
			position_list: {}, //state for getting positions
			assessmentQuestions: [],
      		total: "",
      		errors: {},
      		changes: false,
      		setTotal: true,
      		questions: "",
      		changeQuestions: true,
      		searchValue: "",
      		selectedCategory: 0,
      		selectedType: 0,
      		selectedDifficulty: 0,
      		chkbox: false,
      		filteredQuestions: [],
      		remarksEditorState: EditorState.createEmpty(),
      		loadRemarks: true,
      		prevMark: "",
      		questionMap: {},
      		teacherDetailsMap: {},
      		loadingGradePage: false,
      		openDeleteDialog: false,
      		deleteQuestion: null,
      		openDeleteSelectedDialog: false,
      		openInfoDialog: false,
      		infoMessage: "",
			disabled: false,
			isStudentViewLoading: false,
			addPartSectionLoading: false,
			attachment: '',
			isViewModalLoading: false,
			states: '',
			studentView: false,
			limit: 300,
			offset: 0,
			search_term: "",
			currentPage: 0,
			sort_column: "created_at",
			sort_direction: "DESC",
			rowsPerPage: 300,
			isTableDataLoading: false,
			count: 10,
			filters: [],
			selectedFilters: [],
			selectedGrades: null,
			selectedChapters: null,
			selectedsubjects: null,
			selectedAuthors: null,
			selectedYears: null,
			selectedCategories: null,
			activeTab: 1,
			selectedTerms: null,
			selectedSources: null,
			selectedTeachers: null,
			checked: false,
			selectedTypes: null,
			selectedDifficulties: null,
			selectedLanguages: null,
			assessment: "",
			teachers: [],
			allCategories: [],
			allLanguages: [],
			allSubjects: [],
			allAuthors: [],
			allSources: [],
			allYears: [],
			allTypes: [],
			allDifficulties: [],
			allGrades: [],
			allTerms: [],
			allChapters: [],
			allPrivileges: [],
			allCreators: [],
			filterValues: [],
			selectedStartDate: null,
			selectedEndDate: null,
			assessment_parts: [],
			assessment_sections: [],
			notations: [],
			part_list: [],
			section_modal: false,
			openDialog: false,
			selectedPart: null,
			selectedAssessmentId: null,
			showAddQuestionsModal: false,
			part_title: '',
			no_of_sections: '',
			allow_part_instruction: '',
			part_instruction: '',
			display_order: 0,
			section_title: '',
			allow_section_instruction: '',
			section_instruction: '',
			allow_optional_questions: false,
			no_of_required_questions: null,
			no_of_questions_to_answer: null,
			section_display_order: 0,
			selected_notation: null,
			selected_assessment_part: null,
			add_section_loading: false,
			snackbar: {
				open: false,
				message: '',
				severity: '',
			},
			openPartEdit: false,
			selectedEditPart: null,
			update_loading: false,
			openSectionEdit: false,
			selectedEditSection: null,
			totalQuestionCount: 0,
			totalFilteredCounts: 0,
			isFilterPanelVisible: true,
			QusLoding: false

		};

		this.onSave = this.onSave.bind(this);
		this.finalizeAssessment = this.finalizeAssessment.bind(this);
		this.setForReviewAssessment = this.setForReviewAssessment.bind(this);
		this.makeReadyAssessment = this.makeReadyAssessment.bind(this);
		this.publishAssessment = this.publishAssessment.bind(this);
		this.retireAssessment = this.retireAssessment.bind(this);
		this.unpublishAssessment = this.unpublishAssessment.bind(this);
		this.makeEditableAssessment = this.makeEditableAssessment.bind(this);
		this.orderQuestions = this.orderQuestions.bind(this)
		this.handleSelectQuestion = this.handleSelectQuestion.bind(this);
		this.onViewFinalizeQuestion = this.onViewFinalizeQuestion.bind(this);
	}

	async componentDidMount() {
		if (window.KTSelect2) window.KTSelect2.init();
		if (window.KTBootstrapDatepicker) window.KTBootstrapDatepicker.init();
		if (window.KTIONRangeSlider) window.KTIONRangeSlider.init();
		if (window.KTApp.initComponents) window.KTApp.initComponents();
		if (window.$) window.$(".selectpicker").selectpicker();
		if (typeof window.KTLayoutStickyCard !== "undefined") {
			window.KTLayoutStickyCard.update();
		} else {
			if (window.KTLayoutStickyCard)
				window.KTLayoutStickyCard.init("kt_page_sticky_card");
		}

		await this.fetchAllQuestionMetaData()

		const assessment = JSON.parse(sessionStorage.getItem("setup_assessment"));

		await this.loadAssessmentPartSectionData(assessment);

		await this.props.assessment;

		this.setState({ assessment_title: this.state.assessment.title });

		let disabled
		let ques = await this.props?.assessmentFilteredQuestions.filter(val => val?.sub_questions === null)
		for (let k = 0; k <= ques.length - 1; k++) {
			if (ques[k]?.mark_allocation === 0) {
				disabled = true
			}
		}

		this.setState({ assessmentQuestionsData: this.props?.assessmentFilteredQuestions, disabled: disabled });

		const defaultNotation = this.state.notations.find(n => n.notation_type === 'Numeric');

		this.setState({
			selected_notation: defaultNotation ? defaultNotation.notation_id : ''
		});

		this.onDatatableActionEvent();
	}

	async componentDidUpdate(prevProps, prevState) {
		if (
			this.state.assessmentQuestionsData &&
			this.state.assessmentQuestionsData.length &&
			!this.state.assessmentQuestionsData.length &&
			!this.state.deletion
		) {
			var question_list = this.props?.assessmentFilteredQuestions, i;

			for (i = 0; i < question_list.length; i++) {
				question_list[i]["question_number"] = i + 1; //adding "question_number" as prperty for each questions
			}
			this.setState({ assessmentQuestionsData: question_list });
			this.setState({ print_questions: question_list });
		}

		if (
			this.props?.assessmentFilteredQuestions &&
			this.props?.assessmentFilteredQuestions.length > 0 &&
			!this.props.question
		) {
			await this.props.getQuestionContent(this.props.sharedQuestions[0]);
		}

		if (
			this.props?.assessmentFilteredQuestions &&
			this.props?.assessmentFilteredQuestions.length &&
			this.state.get_content
		) {
			this.setState({ get_content: false });
			await this.props.getAllQuestionContents({
				questions: this.props?.assessmentFilteredQuestions,
			});
		}

		let disabled
		let ques = await this.props?.assessmentFilteredQuestions.filter(val => val?.sub_questions === null)
		for (let k = 0; k <= ques.length - 1; k++) {
			if (ques[k]?.mark_allocation === 0) {
				disabled = true
			}
		}

		if (
			this.state.assessmentQuestionsData &&
			this.state.assessmentQuestionsData.length &&
			_.isEqual({}, this.state.mark_allocation)
		) {

			var list = {},
				pos = {};
			var i,
				total = 0;

			for (i = 0; i < this.state.assessmentQuestionsData.length; i++) {
				var question_id = this.state.assessmentQuestionsData[i].question_id; //getting each question_id

				pos[question_id] = "";
				if (this.state.assessmentQuestionsData[i].mark_allocation) {
					list[question_id] = this.props?.assessmentFilteredQuestions[i].mark_allocation;
					total = total + this.props?.assessmentFilteredQuestions[i].mark_allocation;
				} else {
					list[question_id] = "";
				}
			}

			this.setState({
				mark_allocation: list,
				total: total,
				position_list: pos, //taking the positions list of above quesitons
				disabled: disabled
			});
		}

		if (
			this.props.assessment &&
			this.props.assessment !== prevProps.assessment
		) {
			this.loadAssessmentPartSectionData(this.props.assessment);
		}

		if (
			prevState.notations !== this.state.notations &&
			this.state.notations.length > 0 &&
			!this.state.selected_notation
		) {
			const defaultNotation = this.state.notations.find(n => n.notation_type === 'Numeric');
			this.setState({
				selected_notation: defaultNotation ? defaultNotation.notation_id : ''
			});
		}

		window.$("#finalize-tab").children().prop("disabled", false);
		window.$(".selectPicker").selectpicker("refresh");
		window.$("#question-difficulty").selectpicker("refresh");
		window.$("#question-type").selectpicker("refresh");
		window.$("#question-category").selectpicker("refresh");
	}

	loadAssessmentPartSectionData = async (assessment) => {
		this.setState({ selectedAssessmentId: assessment.assessment_id });
		this.setState({ assessment: assessment }, async () => {
			try {
				this.setState({ addPartSectionLoading: true });
				const part_section_data = await assessmentService.getAssessmentPartSectionData(assessment.assessment_id);

				this.setState({
					assessment_parts: part_section_data.data.parts,
					assessment_sections: part_section_data.data.sections,
					notations: part_section_data.data.notations,
					part_list: part_section_data.data.part_list,
					addPartSectionLoading: false
				});

				if (part_section_data.data.parts.length > 0) {
					await this.fetchAllAssessmentQuestions();
				}
				this.setState({
					assessmentAllQuestionsData: this.props?.assessmentFilteredQuestions
				});
			} catch (error) {
				console.error('Error loading assessment data:', error);
			}
		});
	};

	onDatatableActionEvent() {
		window.$(document).on('click', '.view-question-btn', (e) => {
			const _target = e.target
			const idx = _target.getAttribute('dataindex')
			this.onViewFinalizeQuestion(this.state.assessmentQuestionsData[idx])
			window.$('#view-details').modal('show')
		})
	}

	fetchAllQuestionMetaData = async () => {
		const fetchQuestionMetaData =
			await createService.getAllQuestionMetaData();

		await Promise.all([fetchQuestionMetaData])
			.then((response) => {
				const [questionMetaDataResponse] = response;

				this.setState({
					allCategories: questionMetaDataResponse.data.find(
						(item) => "categories" in item
					).categories,
					allLanguages: questionMetaDataResponse.data.find(
						(item) => "languages" in item
					).languages,
					allTypes: questionMetaDataResponse.data.find(
						(item) => "types" in item
					).types,
					allSubjects: questionMetaDataResponse.data.find(
						(item) => "subjects" in item
					).subjects,
					allAuthors: questionMetaDataResponse.data.find(
						(item) => "authors" in item
					).authors,
					allSources: questionMetaDataResponse.data.find(
						(item) => "sources" in item
					).sources,
					allYears: questionMetaDataResponse.data.find(
						(item) => "years" in item
					).years,
					allDifficulties: questionMetaDataResponse.data.find(
						(item) => "difficulty_types" in item
					).difficulty_types,
					allGrades: questionMetaDataResponse.data.find(
						(item) => "grades" in item
					).grades,
					allTerms: questionMetaDataResponse.data.find(
						(item) => "terms" in item
					).terms,
					allChapters: questionMetaDataResponse.data.find(
						(item) => "chapters" in item
					).chapters,
					allPrivileges: questionMetaDataResponse.data.find(
						(item) => "privileges" in item
					).privileges,
					allCreators: questionMetaDataResponse.data.find(
						(item) => "creators" in item
					).creators,
				});
			})
			.catch((error) => {
				this.setState({
					isTableDataLoading: false,
				});
			});
	}

	fetchAllAssessmentQuestions = async () => {
		const {
			assessment,
			limit,
			offset,
			sort_column,
			sort_direction,
			search_term,
			selectedCategories,
			selectedAuthors,
			selectedChapters,
			selectedGrades,
			selectedDifficulties,
			selectedLanguages,
			selectedTypes,
			selectedTerms,
			selectedYears,
			selectedsubjects,
			selectedSources,
			selectedTeachers,
			selectedStartDate,
			selectedEndDate,
		} = this.state;
		this.setState({ QusLoding: true })

		const asses = JSON.parse(sessionStorage.getItem("setup_assessment"));

		const assessmentId = assessment.assessment_id || asses.assessment_id;

		await Promise.all([
			this.props.getAllQuestions(),
			this.props.getAllAssessmentQuestions(
				assessmentId,
				limit,
				offset,
				sort_column,
				sort_direction,
				search_term,
				selectedCategories,
				selectedAuthors,
				selectedChapters,
				selectedGrades,
				selectedDifficulties,
				selectedLanguages,
				selectedTypes,
				selectedTerms,
				selectedYears,
				selectedsubjects,
				selectedSources,
				selectedTeachers,
				selectedStartDate,
				selectedEndDate
			),
			this.props.getQuestionMetaData(),
			this.props.getAllLibraryQuestions()
		]);


		await this.props.getAllQuestionContentsByType({
			questions: this.props?.assessmentFilteredQuestions,
		});


		this.setState({
			assessmentQuestionsData: this.props?.assessmentFilteredQuestions,
			totalQuestionCount: this.props?.sections?.reduce(
				(sum, s) => sum + (s.total_question_count || 0),
				0
			),
			totalFilteredCounts: this.props?.totalFilteredCount,
			teachers: this.props?.teachers,
			limit: this.state.rowsPerPage,
			addPartSectionLoading: false,
			QusLoding: false
		});

		this.orderQuestions();
	};

	validateTotalRealCount = () => {
		const { totalQuestionCount } = this.state;
		const { totalFilteredCounts } = this.state;

		if (totalQuestionCount === totalFilteredCounts && totalQuestionCount > 0) {
			return true;
		}
		return false;
	};

	// checking whether all questions are MCQS or not
	checkingForAllMcqs() {
		var AllMcqs = true;

		var question_list = this.state.assessmentQuestionsData,
			i;
		for (i = 0; i < this.state.assessmentQuestionsData.length; i++) {
			if (question_list[i]["question_type"] !== "MCQ") {
				AllMcqs = false;
			}
		}

		return AllMcqs;
	}

	getQuestionPassageContent(passage_id) {
		if (passage_id !== null) {
			let questionPassages = this.props.allQuestionMetaData.find(item => 'passages' in item)?.passages;
			const passage = questionPassages?.find(
				(passage) => passage.passage_id == parseInt(passage_id)
			);

			if (!passage?.content) return null;

			try {
				const parsedContent = JSON.parse(passage.content);

				// Validate it's an array and the first item has required Draft.js fields
				if (
					Array.isArray(parsedContent) &&
					parsedContent[0]?.blocks &&
					parsedContent[0]?.entityMap !== undefined
				) {
					const passageContentState = EditorState.createWithContent(
						convertFromRaw(parsedContent[0])
					);
					return passageContentState;
				}
			} catch (error) {
				console.error("Invalid passage content JSON:", error);
				return null;
			}
		}
		return null;
	}

	async onViewFinalizeQuestion(element, e) {

		this.setState({
			editorQuestionState: '',
			editPassageContentState: '',
			editorAnswerStates: '',
			editorAnswerStateDescriptive: ''
		})

		let tempAnswerStates = [];
		let tempAnswer = [];
		this.setState({ isViewModalLoading: true });

		await this.props.getLibraryQuestionContent(element);

		if (element?.is_passage === true && element?.passage_id !== null) {
			this.setState({ editPassageContentState: this.getQuestionPassageContent(element?.passage_id) });
		}

		if (this.props?.libraryQuestionContent) {
			let states = await JSON.parse(this.props?.libraryQuestionContent);
			this.setState({ states: states });
			let tempQuestionState = EditorState.createWithContent(convertFromRaw(states[0]));
			this.setState({ editorQuestionState: tempQuestionState });
		}

		if (element?.question_type === questionTypeConstants.DESCRIPTIVE.name) {

			await this.props.getLibraryAnswerContent(element);
			let states = await JSON.parse(this.props?.libraryAnswerContent);
			let Ans = EditorState.createWithContent(convertFromRaw(states[0]))
			this.setState({ editorAnswerStateDescriptive: Ans })

		}

		else if (element?.question_type === questionTypeConstants.SUBQUESTION.name && element.is_subquestion === "true") {

			await this.props.getLibraryAnswerContent(element);
			let states = await JSON.parse(this.props?.libraryAnswerContent);
			let Ans = EditorState.createWithContent(convertFromRaw(states[0]))
			this.setState({ editorAnswerStateDescriptive: Ans })

		}

		else if (element?.question_type === questionTypeConstants.MCQ.name) {
			if (this.state.states) {
				this.state.states.shift();
				this.state.states.forEach(state => {
					tempAnswerStates.push(EditorState.createWithContent(convertFromRaw(state)))
				});
			}
			if (this.props.libraryQuestion.answer) {
				this.props.libraryQuestion.answer.split(',').map((answer) => {
					tempAnswer.push(parseInt(answer) > 0);
				});
				this.setState({
					editorAnswerStates: tempAnswerStates,
					selectedChoices: tempAnswer
				})
			}
		}

		else if (element?.question_type === questionTypeConstants.SUBMISSION.name) {
			await this.props.getLibraryAnswerContent(element);
			let attachmentName = this.props?.libraryAnswerContent.replace(/^\[(.+)\]$/, "$1").replace(/"\"$/, "$1").split(',');
			this.setState({
				attachment: attachmentName
			});
		}

		this.setState({ isViewModalLoading: false });
	}

	orderQuestions() {
		var question_list = this.state.assessmentQuestionsData,
			i;
		for (i = 0; i < this.state.assessmentQuestionsData.length; i++) {
			question_list[i]["question_number"] = i + 1;
		}
		this.setState({
			assessmentQuestionsData: question_list,
		});
	}

	async onChangeMarks(e, el, i) {
		var marks = this.state.mark_allocation;
		marks[el.question_id] = e.target.value;
		this.setState({ mark_allocation: marks });
	}

	async handleSelectQuestion(e, el) {
		// select multiple questions from list of questions in the assessment
		var Squestions = this.state.selectedQuestions;
		if (e.target.checked) {
			Squestions.push(e.target.value);
			if (el?.sub_questions !== null) {
				let subs = el?.sub_questions.split(",")
				for (let i = 0; i <= subs?.length - 1; i++) {
					Squestions.push(subs[i])
				}
			}
		} else {
			var index = Squestions.indexOf(e.target.value);
			if (index !== -1) {
				Squestions.splice(index, 1);
			}
			if (el?.sub_questions !== null) {
				let subs = el?.sub_questions.split(",")
				for (let i = 0; i <= subs?.length - 1; i++) {
					var index = Squestions.indexOf(subs[i]);
					if (index !== -1) {
						Squestions.splice(index, 1);
					}
				}
			}
		}
		this.setState({
			selectedQuestions: Squestions,
		});
	}

	handleSelectMyQuestions = (e) => {
		const isChecked = e.target.checked;
		this.setState(
			{
				checked: isChecked,
				selectedTeachers: isChecked ? sessionStorage.getItem("user_id") : null
			},
			() => {
				this.fetchAllAssessmentQuestions();
			}
		);
	};

	async onDelete(e, el) {
		// Delete one selected question from an assessment
		this.setState({
			deletion: true,
		});

		await window.Swal.fire({
			text: "You will loose the current marks/position allocation. Do you want to proceed?",
			icon: "warning",
			showCancelButton: true,
			buttonsStyling: !1,
			confirmButtonText: "Yes",
			cancelButtonText: "No",
			customClass: {
				confirmButton: `btn font-weight-bold ${cancelClass}`,
				cancelButton: `btn font-weight-bold ${confirmClass}`,
			},
			onOpen: (modalElement) => {
				if (customer === customerConstants.EXO_CUSTOMER2) {
					modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
					modalElement.querySelector('.swal2-cancel').setAttribute('id', 'cancelButtonId');
				}
			}
		}).then(async (action) => {
			if (action.isConfirmed) {
				var assessmentQuestionsData = this.state.assessmentQuestionsData;
				var questions = this.state.to_delete;
				var marks = this.state.mark_allocation;
				var pos = this.state.position_list;
				if (el?.sub_questions !== null) {
					var ind = assessmentQuestionsData.indexOf(el);

					questions.push(el.question_id);

					if (index !== -1) {
						assessmentQuestionsData.splice(ind, 1);
					}

					delete pos[el.question_id];
					delete marks[el.question_id];
					let subs = el?.sub_questions.split(",")

					for (let i = 0; i <= subs.length - 1; i++) {

						var index = assessmentQuestionsData.findIndex((val) => (val?.question_id === parseInt(subs[i])))
						var total = this.state.total - marks[parseInt(subs[i])];

						questions.push(parseInt(subs[i]));

						if (index !== -1) {
							assessmentQuestionsData.splice(index, 1);
						}

						delete pos[parseInt(subs[i])];
						delete marks[parseInt(subs[i])];
						this.setState({ total: total })
					}

					this.props.getAllQuestionContents({ questions: assessmentQuestionsData });

					this.setState({
						to_delete: questions,
						assessmentQuestionsData: assessmentQuestionsData,
						mark_allocation: marks,
						position_list: pos,
						changes: true,
						total: total,
					});

					this.orderQuestions();
				}

				else {
					var index = assessmentQuestionsData.indexOf(el);
					var total = this.state.total - marks[el.question_id];

					questions.push(el.question_id);

					if (index !== -1) {
						assessmentQuestionsData.splice(index, 1);
					}

					delete pos[el.question_id];
					delete marks[el.question_id];

					this.props.getAllQuestionContents({ questions: assessmentQuestionsData });

					this.setState({
						to_delete: questions,
						assessmentQuestionsData: assessmentQuestionsData,
						mark_allocation: marks,
						position_list: pos,
						changes: true,
						total: total,
					});

					this.orderQuestions();
				}
			}
		});
	}

	async handleDeleteSelectedQuestions() {
		// Delete selected multiple questions
		if (this.state.selectedQuestions.length === 0) {
			await window.Swal.fire({
				text: "No questions selected.",
				icon: "warning",
				buttonsStyling: false,
				confirmButtonText: "OK",
				customClass: {
					confirmButton: `btn font-weight-bold ${confirmClass}`,
				},
				onOpen: (modalElement) => {
					if (customer === customerConstants.EXO_CUSTOMER2) {
						modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
					}
				}
			});
			return;
		}
		this.setState({
			deletion: true,
		});

		await window.Swal.fire({
			text: "You will lose the current marks/position allocation. Do you want to proceed?",
			icon: "warning",
			showCancelButton: true,
			buttonsStyling: !1,
			confirmButtonText: "Yes",
			cancelButtonText: "No",
			customClass: {
				confirmButton: `btn font-weight-bold ${cancelClass}`,
				cancelButton: `btn font-weight-bold ${confirmClass}`,
			},
			onOpen: (modalElement) => {
				if (customer === customerConstants.EXO_CUSTOMER2) {
					modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
					modalElement.querySelector('.swal2-cancel').setAttribute('id', 'cancelButtonId');
				}
			}
		}).then(async (action) => {
			if (action.isConfirmed) {
				var questions = this.state.selectedQuestions;
				this.setState({ to_delete: questions });
				var assessmentQuestionsData = this.state.assessmentQuestionsData.slice();

				var marks = { ...this.state.mark_allocation }; // create a copy of the object
				var pos = { ...this.state.position_list }; // create a copy of the object
				var total = this.state.total;
				questions.forEach((question_id) => {
					let index = -1;
					assessmentQuestionsData.forEach((question, i) => {
						if (question.question_id == question_id) {
							index = i;
							if (index !== -1) {
								assessmentQuestionsData.splice(index, 1);
								total -= marks[question_id];
								delete marks[question_id];
								delete pos[question_id];
							}
						}
					});
				});

				this.setState({
					to_delete: questions,
					assessmentQuestionsData: assessmentQuestionsData,
					mark_allocation: marks,
					position_list: pos,
					changes: true,
					total: total,
					selectedQuestions: [],
				});
				this.orderQuestions();
				await this.onSave();
			}
		});
	}

	handleInfoDialogConfirm = () => {
		this.setState({ openInfoDialog: false });
		if (this.state.infoCallback) {
			this.state.infoCallback();
		}
	};

	async onSave() {
		const assessment_id = this.state.assessment.assessment_id;
		const assessor_id = this.state.assessment.user_role_id;
		const user_id = sessionStorage.getItem("user_id");
		var delete_questions = this.state.to_delete;
		const user_role_id = this.state.assessment.user_role_id;

		var questions = this.state.assessmentQuestionsData;

		this.setState({ isActionLoading: true });

		if (!this.validateSectionQuestionLimits()) {
			this.setState({ isActionLoading: false });
			return;
		}

		if (delete_questions.length) {
			await this.props.removeMyQuestions({
				assessment_id,
				delete_questions,
				assessor_id,
				user_id,
			});
			if (this.props.updateError != "") {
				this.setState({ isActionLoading: false });
				window.Swal.fire({
					title: messageTypes.FAILED_WARNING,
					text: this.props.updateError,
					icon: messageTypes.ERROR,
					customClass: {
						confirmButton: `btn font-weight-bold ${confirmClass}`,
					},
					onOpen: (modalElement) => {
						if (customer === customerConstants.EXO_CUSTOMER2) {
							modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
						}
					}
				});
			} else {
				await this.props.saveUpdates({
					assessment_id,
					questions,
					user_role_id,
				});

				if (this.props.updateError == "") {
					this.setState({
						to_delete: [],
						isActionLoading: false,
					});
					window.Swal.fire({
						title: messageTypes.SUCCESS_WARNING,
						text: "Saved changes successfully!",
						icon: messageTypes.SUCCESS,
						customClass: {
							confirmButton: `btn font-weight-bold ${confirmClass}`,
						},
						onOpen: (modalElement) => {
							if (customer === customerConstants.EXO_CUSTOMER2) {
								modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
							}
						}
					}).then((result) => {
						if (result.isConfirmed) {
							this.fetchAllAssessmentQuestions();
						}
					});
				} else {
					this.setState({ isActionLoading: false });
					window.Swal.fire({
						title: messageTypes.FAILED_WARNING,
						text: this.props.updateError,
						icon: messageTypes.ERROR,
						customClass: {
							confirmButton: `btn font-weight-bold ${confirmClass}`,
						},
						onOpen: (modalElement) => {
							if (customer === customerConstants.EXO_CUSTOMER2) {
								modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
							}
						}
					});
				}
			}
		} else {
			await this.props.saveUpdates({ assessment_id, questions, user_role_id });
			if (this.props.updateError == "") {
				this.setState({ isActionLoading: false });
				window.Swal.fire({
					title: messageTypes.SUCCESS_WARNING,
					text: "Saved changes successfully!",
					icon: messageTypes.SUCCESS,
					customClass: {
						confirmButton: `btn font-weight-bold ${confirmClass}`,
					},
					onOpen: (modalElement) => {
						if (customer === customerConstants.EXO_CUSTOMER2) {
							modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
						}
					}
				}).then((result) => {
					if (result.isConfirmed) {
						this.fetchAllAssessmentQuestions();
					}
				});
				let disabled
				let ques = await this.props?.assessmentFilteredQuestions.filter(val => val?.sub_questions === null)
				for (let k = 0; k <= ques.length - 1; k++) {
					if (ques[k]?.mark_allocation === 0) {
						disabled = true
					}
				}
				this.setState({ disabled: disabled })
			} else {
				this.setState({ isActionLoading: false });
				window.Swal.fire({
					title: messageTypes.FAILED_WARNING,
					text: this.props.updateError,
					icon: messageTypes.ERROR,
					customClass: {
						confirmButton: `btn font-weight-bold ${confirmClass}`,
					},
					onOpen: (modalElement) => {
						if (customer === customerConstants.EXO_CUSTOMER2) {
							modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
						}
					}
				});
			}
		}
		this.setState({
			changes: false,
		});
	}

	async finalizeAssessment() {
		if (this.validateTotalRealCount()) {
			this.setState({ isActionLoading: true });
			await this.props.finalizeAssessment(this.state.assessment);
			if (this.props.finalizeError == "") {
				this.state.assessment["assessment_state"] = "Ready";
				sessionStorage.setItem("setup_assessment", JSON.stringify(this.state.assessment));
				this.setState({ isActionLoading: false });
				window.Swal.fire({
					title: messageTypes.SUCCESS_WARNING,
					text: this.props.finalizeSuccess,
					icon: messageTypes.SUCCESS,
					customClass: {
						confirmButton: `btn font-weight-bold ${confirmClass}`,
					},
					onOpen: (modalElement) => {
						if (customer === customerConstants.EXO_CUSTOMER2) {
							modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
						}
					}
				}).then((result) => {
					if (result.isConfirmed) {
						const assessment = JSON.parse(sessionStorage.getItem("setup_assessment"));
						this.setState({ assessment: assessment });
						this.fetchAllAssessmentQuestions();
					}
				});
			}

			else {
				this.setState({ isActionLoading: false });
				window.Swal.fire({
					title: messageTypes.FAILED_WARNING,
					text: this.props.finalizeError,
					icon: messageTypes.ERROR,
					customClass: {
						confirmButton: `btn font-weight-bold ${confirmClass}`,
					},
					onOpen: (modalElement) => {
						if (customer === customerConstants.EXO_CUSTOMER2) {
							modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
						}
					}
				});
			}
		} else {
			await window.Swal.fire({
				title: 'Incomplete assessment',
				text: 'Assessment is not complete. Check you have added all questions (counts mismatch).',
				icon: 'warning',
				confirmButtonText: 'OK',
				buttonsStyling: !1,
				customClass: {
					confirmButton: `btn font-weight-bold ${confirmClass}`,
				},
				onOpen: (modalElement) => {
					if (customer === customerConstants.EXO_CUSTOMER2) {
						modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
					}
				}
			});
			return;
		}
	}





	async setForReviewAssessment() {
		await window.Swal.fire({
			text: "Assessment will be set under review! Do you want to proceed?",
			icon: "warning",
			showCancelButton: true,
			buttonsStyling: !1,
			confirmButtonText: "Yes",
			cancelButtonText: "No",
			customClass: {
				confirmButton: `btn font-weight-bold ${cancelClass}`,
				cancelButton: `btn font-weight-bold ${confirmClass}`,
			},
			onOpen: (modalElement) => {
				if (customer === customerConstants.EXO_CUSTOMER2) {
					modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
					modalElement.querySelector('.swal2-cancel').setAttribute('id', 'cancelButtonId');
				}
			}
		}).then(async (action) => {
			if (action.isConfirmed) {
				window.Swal.showLoading();
				let user_id = sessionStorage.getItem("manage_user_id");
				await this.props.getTeacherMe(user_id);
				const assessmentItem = {
					paper_list: [parseInt(this.state.assessment?.assessment_id)],
					category_id: null,
					grade_id: null,
					language_id: null,
					chapter_id: null,
					subject_id: null,
					difficulty_id: null,
					author_id: null,
					year_id: null,
					term_id: null,
					privilege_id: null,
					status_id: 3,
					source_id: null,
					exam_category_id: null,
					assessment_state: "Review",
					user_id: user_id,
					first_name: this.props.teacher[0]?.first_name,
					last_name: this.props.teacher[0]?.last_name
				};
				let response = await candidateService.updateAllPapers(assessmentItem);
				if (response.success) {
					this.state.assessment["assessment_state"] = "Review";
					sessionStorage.setItem("setup_assessment", JSON.stringify(this.state.assessment));
					window.Swal.fire({
						title: messageTypes.SUCCESS_WARNING,
						text: "Assessment Set for Review Successfully!",
						icon: messageTypes.SUCCESS,
						customClass: {
							confirmButton: `btn font-weight-bold ${confirmClass}`,
						},
						onOpen: (modalElement) => {
							if (customer === customerConstants.EXO_CUSTOMER2) {
								modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
							}
						}
					}).then((result) => {
						if (result.isConfirmed) {
							const assessment = JSON.parse(sessionStorage.getItem("setup_assessment"));
							this.setState({ assessment: assessment });
							this.fetchAllAssessmentQuestions();
						}
					});
				}

				else {
					window.Swal.fire({
						title: messageTypes.FAILED_WARNING,
						text: this.props.finalizeError,
						icon: messageTypes.ERROR,
						customClass: {
							confirmButton: `btn font-weight-bold ${confirmClass}`,
						},
						onOpen: (modalElement) => {
							if (customer === customerConstants.EXO_CUSTOMER2) {
								modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
							}
						}
					});
				}
			}
		});
	}

	async makeReadyAssessment() {
		await window.Swal.fire({
			text: "Assessment will be reset to ready! Do you want to proceed?",
			icon: "warning",
			showCancelButton: true,
			buttonsStyling: !1,
			confirmButtonText: "Yes",
			cancelButtonText: "No",
			customClass: {
				confirmButton: `btn font-weight-bold ${cancelClass}`,
				cancelButton: `btn font-weight-bold ${confirmClass}`,
			},
			onOpen: (modalElement) => {
				if (customer === customerConstants.EXO_CUSTOMER2) {
					modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
					modalElement.querySelector('.swal2-cancel').setAttribute('id', 'cancelButtonId');
				}
			}
		}).then(async (action) => {
			if (action.isConfirmed) {
				window.Swal.showLoading();
				let user_id = sessionStorage.getItem("manage_user_id");
				await this.props.getTeacherMe(user_id);
				const assessmentItem = {
					paper_list: [parseInt(this.state.assessment?.assessment_id)],
					category_id: null,
					grade_id: null,
					language_id: null,
					chapter_id: null,
					subject_id: null,
					difficulty_id: null,
					author_id: null,
					year_id: null,
					term_id: null,
					privilege_id: null,
					status_id: 2,
					source_id: null,
					exam_category_id: null,
					assessment_state: "Ready",
					user_id: user_id,
					first_name: this.props.teacher[0]?.first_name,
					last_name: this.props.teacher[0]?.last_name
				};
				let response = await candidateService.updateAllPapers(assessmentItem);
				if (response.success) {
					this.state.assessment["assessment_state"] = "Ready";
					sessionStorage.setItem("setup_assessment", JSON.stringify(this.state.assessment));
					window.Swal.fire({
						title: messageTypes.SUCCESS_WARNING,
						text: "Assessment made ready successfully!",
						icon: messageTypes.SUCCESS,
						customClass: {
							confirmButton: `btn font-weight-bold ${confirmClass}`,
						},
						onOpen: (modalElement) => {
							if (customer === customerConstants.EXO_CUSTOMER2) {
								modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
							}
						}
					}).then((result) => {
						if (result.isConfirmed) {
							const assessment = JSON.parse(sessionStorage.getItem("setup_assessment"));
							this.setState({ assessment: assessment });
							this.fetchAllAssessmentQuestions();
						}
					});
				}

				else {
					window.Swal.fire({
						title: messageTypes.FAILED_WARNING,
						text: this.props.finalizeError,
						icon: messageTypes.ERROR,
						customClass: {
							confirmButton: `btn font-weight-bold ${confirmClass}`,
						},
						onOpen: (modalElement) => {
							if (customer === customerConstants.EXO_CUSTOMER2) {
								modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
							}
						}
					});
				}
			}
		});
	}

	getCreatedAtLocal(time) {
		if (time != null) {
			let timeStamp = new Date(time.concat("Z"))
			let d = new Date(timeStamp)
			// let startDate = d.toDateString();
			// let startTime = d.toLocaleTimeString('en-SL');
			let local = moment(timeStamp).local().format("MMMM Do YYYY hh:mm A")
			return local;
		}
		else {
			return "N/A";
		}
	}

	async publishAssessment() {
		await window.Swal.fire({
			text: "Assessment will go live for students and You will not be able to make any modifications! Do you want to publish?",
			icon: "warning",
			showCancelButton: true,
			buttonsStyling: !1,
			confirmButtonText: "Yes",
			cancelButtonText: "No",
			customClass: {
				confirmButton: `btn font-weight-bold ${cancelClass}`,
				cancelButton: `btn font-weight-bold ${confirmClass}`,
			},
			onOpen: (modalElement) => {
				if (customer === customerConstants.EXO_CUSTOMER2) {
					modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
					modalElement.querySelector('.swal2-cancel').setAttribute('id', 'cancelButtonId');
				}
			}
		}).then(async (action) => {
			if (action.isConfirmed) {
				window.Swal.showLoading();
				let user_id = sessionStorage.getItem("manage_user_id");
				await this.props.getTeacherMe(user_id);
				const assessmentItem = {
					paper_list: [parseInt(this.state.assessment?.assessment_id)],
					category_id: null,
					grade_id: null,
					language_id: null,
					chapter_id: null,
					subject_id: null,
					difficulty_id: null,
					author_id: null,
					year_id: null,
					term_id: null,
					privilege_id: null,
					status_id: 4,
					source_id: null,
					exam_category_id: null,
					assessment_state: "Published",
					user_id: user_id,
					first_name: this.props.teacher[0]?.first_name,
					last_name: this.props.teacher[0]?.last_name
				};
				let response = await candidateService.updateAllPapers(assessmentItem);
				if (response.success) {
					this.state.assessment["assessment_state"] = "Published";
					sessionStorage.setItem("setup_assessment", JSON.stringify(this.state.assessment));
					window.Swal.fire({
						title: messageTypes.SUCCESS_WARNING,
						text: "Assessment Published Successfully!",
						icon: messageTypes.SUCCESS,
						customClass: {
							confirmButton: `btn font-weight-bold ${confirmClass}`,
						},
						onOpen: (modalElement) => {
							if (customer === customerConstants.EXO_CUSTOMER2) {
								modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
							}
						}
					}).then((result) => {
						if (result.isConfirmed) {
							const assessment = JSON.parse(sessionStorage.getItem("setup_assessment"));
							this.setState({ assessment: assessment });
							this.fetchAllAssessmentQuestions();
						}
					});
				}

				else {
					window.Swal.fire({
						title: messageTypes.FAILED_WARNING,
						text: this.props.finalizeError,
						icon: messageTypes.ERROR,
						customClass: {
							confirmButton: `btn font-weight-bold ${confirmClass}`,
						},
						onOpen: (modalElement) => {
							if (customer === customerConstants.EXO_CUSTOMER2) {
								modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
							}
						}
					});
				}
			}
		});
	}

	async retireAssessment() {
		await window.Swal.fire({
			text: "Assessment will be removed from live acccess by students! Do you want to retire?",
			icon: "warning",
			showCancelButton: true,
			buttonsStyling: !1,
			confirmButtonText: "Yes",
			cancelButtonText: "No",
			customClass: {
				confirmButton: `btn font-weight-bold ${cancelClass}`,
				cancelButton: `btn font-weight-bold ${confirmClass}`,
			},
			onOpen: (modalElement) => {
				if (customer === customerConstants.EXO_CUSTOMER2) {
					modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
					modalElement.querySelector('.swal2-cancel').setAttribute('id', 'cancelButtonId');
				}
			}
		}).then(async (action) => {
			if (action.isConfirmed) {
				window.Swal.showLoading();
				let user_id = sessionStorage.getItem("manage_user_id");
				await this.props.getTeacherMe(user_id);
				const assessmentItem = {
					paper_list: [parseInt(this.state.assessment?.assessment_id)],
					category_id: null,
					grade_id: null,
					language_id: null,
					chapter_id: null,
					subject_id: null,
					difficulty_id: null,
					author_id: null,
					year_id: null,
					term_id: null,
					privilege_id: null,
					status_id: 5,
					source_id: null,
					exam_category_id: null,
					assessment_state: "Retired",
					user_id: user_id,
					first_name: this.props.teacher[0]?.first_name,
					last_name: this.props.teacher[0]?.last_name
				};
				let response = await candidateService.updateAllPapers(assessmentItem);
				if (response.success) {
					this.state.assessment["assessment_state"] = "Retired";
					sessionStorage.setItem("setup_assessment", JSON.stringify(this.state.assessment));
					window.Swal.fire({
						title: messageTypes.SUCCESS_WARNING,
						text: "Assessment Retired Successfully!",
						icon: messageTypes.SUCCESS,
						customClass: {
							confirmButton: `btn font-weight-bold ${confirmClass}`,
						},
						onOpen: (modalElement) => {
							if (customer === customerConstants.EXO_CUSTOMER2) {
								modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
							}
						}
					}).then((result) => {
						if (result.isConfirmed) {
							const assessment = JSON.parse(sessionStorage.getItem("setup_assessment"));
							this.setState({ assessment: assessment });
							this.fetchAllAssessmentQuestions();
						}
					});
				}

				else {
					window.Swal.fire({
						title: messageTypes.FAILED_WARNING,
						text: response.message,
						icon: messageTypes.ERROR,
						customClass: {
							confirmButton: `btn font-weight-bold ${confirmClass}`,
						},
						onOpen: (modalElement) => {
							if (customer === customerConstants.EXO_CUSTOMER2) {
								modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
							}
						}
					});
				}
			}
		});
	}

	async unpublishAssessment() {
		await window.Swal.fire({
			text: "Assessment will be back to ready to publish status! Do you want to proceed?",
			icon: "warning",
			showCancelButton: true,
			buttonsStyling: !1,
			confirmButtonText: "Yes",
			cancelButtonText: "No",
			customClass: {
				confirmButton: `btn font-weight-bold ${cancelClass}`,
				cancelButton: `btn font-weight-bold ${confirmClass}`,
			},
			onOpen: (modalElement) => {
				if (customer === customerConstants.EXO_CUSTOMER2) {
					modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
					modalElement.querySelector('.swal2-cancel').setAttribute('id', 'cancelButtonId');
				}
			}
		}).then(async (action) => {
			if (action.isConfirmed) {
				window.Swal.showLoading();
				let user_id = sessionStorage.getItem("manage_user_id");
				await this.props.getTeacherMe(user_id);
				const assessmentItem = {
					paper_list: [parseInt(this.state.assessment?.assessment_id)],
					category_id: null,
					grade_id: null,
					language_id: null,
					chapter_id: null,
					subject_id: null,
					difficulty_id: null,
					author_id: null,
					year_id: null,
					term_id: null,
					privilege_id: null,
					status_id: 11,
					source_id: null,
					exam_category_id: null,
					assessment_state: "ReadyToPublish",
					user_id: user_id,
					first_name: this.props.teacher[0]?.first_name,
					last_name: this.props.teacher[0]?.last_name
				};
				let response = await candidateService.updateAllPapers(assessmentItem);
				if (response.success) {
					this.state.assessment["assessment_state"] = "ReadyToPublish";
					sessionStorage.setItem("setup_assessment", JSON.stringify(this.state.assessment));
					window.Swal.fire({
						title: messageTypes.SUCCESS_WARNING,
						text: "Assessment Made Ready to Publish Successfully!",
						icon: messageTypes.SUCCESS,
						customClass: {
							confirmButton: `btn font-weight-bold ${confirmClass}`,
						},
						onOpen: (modalElement) => {
							if (customer === customerConstants.EXO_CUSTOMER2) {
								modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
							}
						}
					}).then((result) => {
						if (result.isConfirmed) {
							const assessment = JSON.parse(sessionStorage.getItem("setup_assessment"));
							this.setState({ assessment: assessment });
							this.fetchAllAssessmentQuestions();
						}
					});
				}

				else {
					window.Swal.fire({
						title: messageTypes.FAILED_WARNING,
						text: this.props.finalizeError,
						icon: messageTypes.ERROR,
						customClass: {
							confirmButton: `btn font-weight-bold ${confirmClass}`,
						},
						onOpen: (modalElement) => {
							if (customer === customerConstants.EXO_CUSTOMER2) {
								modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
							}
						}
					});
				}
			}
		});
	}

	async makeEditableAssessment() {
		this.setState({ isActionLoading: true });
		await this.props.finalizeAssessment(this.state.assessment);
		if (this.props.finalizeError == "") {
			this.state.assessment["assessment_state"] = "Initial";
			sessionStorage.setItem("setup_assessment", JSON.stringify(this.state.assessment));
			this.setState({ isActionLoading: false });
			window.Swal.fire({
				title: messageTypes.SUCCESS_WARNING,
				text: this.props.finalizeSuccess,
				icon: messageTypes.SUCCESS,
				customClass: {
					confirmButton: `btn font-weight-bold ${confirmClass}`,
				},
				onOpen: (modalElement) => {
					if (customer === customerConstants.EXO_CUSTOMER2) {
						modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
					}
				}
			}).then((result) => {
				if (result.isConfirmed) {
					const assessment = JSON.parse(sessionStorage.getItem("setup_assessment"));
					this.setState({ assessment: assessment });
					this.fetchAllAssessmentQuestions();
				}
			});
		}
		else {
			this.setState({ isActionLoading: false });
			window.Swal.fire({
				title: messageTypes.FAILED_WARNING,
				text: this.props.finalizeError,
				icon: messageTypes.ERROR,
				customClass: {
					confirmButton: `btn font-weight-bold ${confirmClass}`,
				},
				onOpen: (modalElement) => {
					if (customer === customerConstants.EXO_CUSTOMER2) {
						modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
					}
				}
			});
		}
	}

	onOptionalChange = (questionId, isOptional) => {
		const questions = [...this.state.assessmentQuestionsData];
		const question = questions.find(q => q.question_id === questionId);
		if (!question) return;

		const sectionId = question.section_id;
		const questionsInSection = questions.filter(q => q.section_id === sectionId);
		const section = this.props.sections?.find(s => s.section_id === sectionId);

		if (!section) return;

		//Prevent optional toggling if section doesn't allow optional questions
		if (!section.allow_optional_questions) {
			window.Swal.fire({
				icon: 'error',
				title: 'Not Allowed',
				text: 'This section does not allow optional questions.',
			});
			return;
		}

		const requiredLimit = parseInt(section.no_of_required_questions || 0, 10);
		const totalMainQuestionsInSection = questionsInSection.filter(q => q.is_subquestion !== "true").length;
		const optionalLimit = totalMainQuestionsInSection - requiredLimit;

		const currentRequiredCount = questionsInSection.filter(
			q => q.is_optional === false && q.is_subquestion !== "true"
		).length;
		const currentOptionalCount = questionsInSection.filter(
			q => q.is_optional === true && q.is_subquestion !== "true"
		).length;

		const updatedQuestions = [...questions];

		// If making required
		if (!isOptional && question.is_optional === true) {
			if (currentRequiredCount >= requiredLimit) {
				const requiredQuestions = questionsInSection.filter(
					q => q.is_optional === false && q.question_id !== questionId && q.is_subquestion !== "true"
				);
				if (requiredQuestions.length > 0) {
					const toMakeOptionalIndex = updatedQuestions.findIndex(q => q.question_id === requiredQuestions[0].question_id);
					if (toMakeOptionalIndex !== -1) {
						updatedQuestions[toMakeOptionalIndex].is_optional = true;

						// Also update its sub-questions
						if (updatedQuestions[toMakeOptionalIndex].sub_questions) {
							updatedQuestions[toMakeOptionalIndex].sub_questions.split(',').forEach(id => {
								const subQIndex = updatedQuestions.findIndex(q => q.question_id === parseInt(id.trim()));
								if (subQIndex !== -1) {
									updatedQuestions[subQIndex].is_optional = true;
								}
							});
						}
					}
				} else {
					window.Swal.fire({
						icon: 'error',
						title: 'Limit Reached',
						text: `You can only have ${requiredLimit} required question(s).`,
					});
					return;
				}
			}
		}

		// If making optional
		if (isOptional && question.is_optional === false) {
			if (currentOptionalCount >= optionalLimit) {
				const optionalQuestions = questionsInSection.filter(
					q => q.is_optional === true && q.question_id !== questionId && q.is_subquestion !== "true"
				);
				if (optionalQuestions.length > 0) {
					const toMakeRequiredIndex = updatedQuestions.findIndex(q => q.question_id === optionalQuestions[0].question_id);
					if (toMakeRequiredIndex !== -1) {
						updatedQuestions[toMakeRequiredIndex].is_optional = false;

						// Also update its sub-questions
						if (updatedQuestions[toMakeRequiredIndex].sub_questions) {
							updatedQuestions[toMakeRequiredIndex].sub_questions.split(',').forEach(id => {
								const subQIndex = updatedQuestions.findIndex(q => q.question_id === parseInt(id.trim()));
								if (subQIndex !== -1) {
									updatedQuestions[subQIndex].is_optional = false;
								}
							});
						}
					}
				} else {
					window.Swal.fire({
						icon: 'error',
						title: 'Limit Reached',
						text: `You can only have ${optionalLimit} optional question(s).`,
					});
					return;
				}
			}
		}

		// Update main question
		const mainIndex = updatedQuestions.findIndex(q => q.question_id === questionId);
		if (mainIndex !== -1) updatedQuestions[mainIndex].is_optional = isOptional;

		// Update sub-questions of this main
		if (question.sub_questions) {
			question.sub_questions.split(',').forEach(id => {
				const subQIndex = updatedQuestions.findIndex(q => q.question_id === parseInt(id.trim()));
				if (subQIndex !== -1) {
					updatedQuestions[subQIndex].is_optional = isOptional;
				}
			});
		}

		this.setState({ assessmentQuestionsData: updatedQuestions });
	};

	onPositionChange() {
		var assessmentQuestionsNew = this.props?.assessmentFilteredQuestions;
		var questions = this.state.assessmentQuestionsData;
		var questionContent = this.props.questionContents;
		var position_list = this.state.position_list;
		var new_assQ = new Array(this.props?.assessmentFilteredQuestions.length).fill("");
		var new_q = new Array(this.props?.assessmentFilteredQuestions.length).fill("");
		var new_qcnt = new Array(this.props?.assessmentFilteredQuestions.length).fill("");

		var tmp_assQ = [],
			tmp_q = [],
			tmp_qcnt = [];

		var i = 0,
			k = 0;

		for (i = 0; i < this.state.assessmentQuestionsData.length; i++) {
			var question_id = this.state.assessmentQuestionsData[i]["question_id"];
			if (position_list[question_id] != "" && position_list[question_id] > 0) {
				var newIndex = position_list[question_id] - 1;
				new_assQ[newIndex] = assessmentQuestionsNew[i];
				new_q[newIndex] = questions[i];
				new_qcnt[newIndex] = questionContent[i];
				position_list[question_id] = "";
			} else {
				tmp_assQ.push(assessmentQuestionsNew[i]);
				tmp_q.push(questions[i]);
				tmp_qcnt.push(questionContent[i]);
			}
		}

		for (i = 0; i < this.state.assessmentQuestionsData.length; i++) {
			if (new_assQ[i] == "") {
				new_assQ[i] = tmp_assQ[k];
				new_q[i] = tmp_q[k];
				new_qcnt[i] = tmp_qcnt[k];
				k = k + 1;
			}

			new_q[i]["question_number"] = i + 1;
		}

		this.setState({
			assessmentQuestionsData: new_q,
			questionContents: new_qcnt,
			position_list: position_list,
			changes: true,
		});

		this.props.applyPositionChangeLocal({ list: new_assQ, contents: new_qcnt });
	}

	//function for printing all available questions
	handlePrint = async () => {
		await this.props.getAllQuestionContentsByType({
			questions: this.state.assessmentQuestionsData,
		});

		this.setState({
			questions_contents_by_type: this.props.questionContentsByType,
		});

		let questionsByType = this.state.questions_contents_by_type
		let html = "";

		if (questionsByType["MCQ"]) {
			html += "<h3>Section 1: Multiple Choice Questions</h3>";
			html += "<p>Underline the suitable answer</p>";

			html += questionsByType["MCQ"]
				.map((q, i) => {
					const blocks = JSON.parse(q)[0].blocks;

					if (blocks && blocks.length > 0) {
						let questions = ""; // Move the initialization here
						let answers = ""; // Move the initialization here

						blocks.forEach((block) => {
							let text = block.text;
							let inlineStyleRanges = block.inlineStyleRanges || [];

							// Process inline style ranges for formatting
							if (inlineStyleRanges.length > 0) {
								let formattedText = ""
								let lastIndex = 0

								inlineStyleRanges.forEach((range) => {
									const { offset, length, style } = range
									const substring = text.slice(offset, offset + length)

									// Append the preceding unformatted text
									formattedText += text.slice(lastIndex, offset)

									// Apply the appropriate formatting to the substring
									if (style === "BOLD") {
										formattedText += `<strong>${substring}</strong>`
									} else if (style === "ITALIC") {
										formattedText += `<em>${substring}</em>`
									} else if (style === "UNDERLINE") {
										formattedText += `<u>${substring}</u>`
									}

									lastIndex = offset + length
								})

								// Append the remaining unformatted text
								formattedText += text.slice(lastIndex)

								text = formattedText
							}

							questions += text
						})

						answers = JSON.parse(q)
							.slice(1)
							.map((a, j) => {
								let answerText = ""
								let answerImage = ""

								if (a.blocks && a.blocks.length > 0) {
									answerText = a.blocks[0].text
									let inlineStyleRanges = a.blocks[0].inlineStyleRanges || []

									// Process inline style ranges for formatting
									if (inlineStyleRanges.length > 0) {
										let formattedText = ""
										let lastIndex = 0

										inlineStyleRanges.forEach((range) => {
											const { offset, length, style } = range
											const substring = answerText.slice(
												offset,
												offset + length
											)

											// Append the preceding unformatted text
											formattedText += answerText.slice(lastIndex, offset)

											// Apply the appropriate formatting to the substring
											if (style === "BOLD") {
												formattedText += `<strong>${substring}</strong>`
											} else if (style === "ITALIC") {
												formattedText += `<em>${substring}</em>`
											} else if (style === "UNDERLINE") {
												formattedText += `<u>${substring}</u>`
											}

											lastIndex = offset + length
										})

										// Append the remaining unformatted text
										formattedText += answerText.slice(lastIndex)

										answerText = formattedText
									}
								}

								if (typeof a.entityMap === "object" && a.entityMap !== null) {
									Object.values(a.entityMap).forEach((entityMap) => {
										if (entityMap.type === "IMAGE") {
											const imageUrl = entityMap.data.src
											answerImage = `<img src="${imageUrl}" alt="Image" />`
										}
									})
								}

								return `<div>${String.fromCharCode(97 + j)}) ${answerImage ? answerImage : answerText
									}</div>`
							})
							.join("")

						return `<div style="margin-left: 20px;">${i + 1
							}.${questions}<br><div style="margin-left: 35px;">${answers}</div></div>`
					}
				})
				.join("")
		}

		if (questionsByType["Descriptive"]) {
			html += "<h3>Section 2: Short Answer</h3>"
			html += "<p>Write a short answer</p>"

			html += questionsByType["Descriptive"]
				.map((q, i) => {
					const content = JSON.parse(q)[0]
					const blocks = content.blocks
					const entityMap = content.entityMap

					let question = ""
					let answers = ""

					if (entityMap && blocks && blocks.length > 0) {
						blocks.forEach((block) => {
							let text = block.text
							let inlineStyleRanges = block.inlineStyleRanges || []
							let entityRanges = block.entityRanges || []
							let formattedText = ""

							let currentIndex = 0
							inlineStyleRanges.forEach((range) => {
								const nonFormattedSubstring = text.slice(
									currentIndex,
									range.offset
								)
								const formattedSubstring = text.slice(
									range.offset,
									range.offset + range.length
								)
								formattedText += nonFormattedSubstring

								if (range.style === "BOLD") {
									formattedText += `<strong>${formattedSubstring}</strong>`
								} else if (range.style === "ITALIC") {
									formattedText += `<em>${formattedSubstring}</em>`
								} else if (range.style === "UNDERLINE") {
									formattedText += `<u>${formattedSubstring}</u>`
								}

								currentIndex = range.offset + range.length
							})

							formattedText += text.slice(currentIndex)

							question += formattedText
						})
					}

					return `<div style="margin-left: 20px;font-family: Arial;">${i + 1
						}. ${question}<br></div>`
				})
				.join("")
		}

		if (questionsByType["Submission"]) {
			html += "<h3>Section 3: Essay</h3>"
			html += "<p>Write answer in additional paper and attach it</p>"

			html += questionsByType["Submission"]
				.map((q, i) => {
					const blocks = JSON.parse(q)[0].blocks

					let question = ""

					if (blocks && blocks.length > 0) {
						blocks.forEach((block) => {
							let text = block.text
							let inlineStyleRanges = block.inlineStyleRanges || []

							if (inlineStyleRanges.length > 0) {
								let formattedText = ""
								let lastIndex = 0

								inlineStyleRanges.forEach((range) => {
									const { offset, length, style } = range
									const substring = text.slice(offset, offset + length)

									formattedText += text.slice(lastIndex, offset)

									if (style === "BOLD") {
										formattedText += `<strong>${substring}</strong>`
									} else if (style === "ITALIC") {
										formattedText += `<em>${substring}</em>`
									} else if (style === "UNDERLINE") {
										formattedText += `<u>${substring}</u>`
									}
									// Add additional conditions for other formatting options
									else if (style === "STRIKETHROUGH") {
										formattedText += `<del>${substring}</del>`
									} else if (style === "HIGHLIGHT") {
										formattedText += `<span style="background-color: yellow;">${substring}</span>`
									}
									// Add more conditions for other formatting options as needed

									lastIndex = offset + length
								})

								formattedText += text.slice(lastIndex)

								text = formattedText
							}

							question += text
						})
					}

					return `<div style="margin-left: 20px;">${i + 1
						}. ${question}<br></div>`
				})
				.join("")
		}

		const fullHtml = `
        <html>
        <head>
            <title>Exam</title>
        </head>
        <body>
            <h4><u>Test Assessment</u></h4>
            <p>Instructions: Please read each question carefully and select the best answer.</p>
            ${html}
        </body>
        </html>
    `

		const popupWindow = window.open("", "_blank")
		popupWindow.document.write(fullHtml)
		popupWindow.print()
	}

	// function to get autoshuffle done for only for mcqs
	handleAutoShuffle = () => {
		this.setState(
			(prevState) => ({
				auto_shuffle: !prevState.auto_shuffle,
			}),
			() => {
				try {
					const requestOptions = {
						method: "POST",
						headers: APIHandler.getHeader(
							config.azure_ad_config.apis.ASSESSMENT.name
						),
						body: JSON.stringify({
							auto_shuffle: this.state.auto_shuffle,
						}),
					}

					fetch(
						`${config.oat_api_url}/assessment/autoshuffle-mcqs/${this.state.assessment.assessment_id}`,
						requestOptions
					).then(APIHandler.handleResponse)
				} catch (err) {
					return { error: "Some error occured. Please try again!" }
				}
			}
		)
	}

	onChangeAllMarks = (j) => {
		var list = this.state.mark_allocation
		const keys = Object.keys(list)
		for (let key of keys) {
			list[key] = j.target.value
		}
		this.setState({ mark_allocation: list, allMarks: j.target.value })
	}

	onSetAllMarks = () => {
		var total = this.state.total
		var question_list = this.state.assessmentAllQuestionsData?.filter(val => val?.sub_questions === null)
		if (this.state.allMarks > 0) {
			for (var i = 0; i <= question_list.length - 1; i++) {
				if (question_list[i]?.sub_questions === null) {
					question_list[i].mark_allocation = this.state.allMarks
					this.onSetMarks(question_list[i], i);
				}
			}
			total = this.state.allMarks * question_list.length
			this.setState({
				total: total,
				changes: true
			})
		} else {
			window.Swal.fire({
				title: messageTypes.WARNING,
				text: "Invalid Mark Allocated.",
				icon: messageTypes.WARNING,
				customClass: {
					confirmButton: `btn font-weight-bold ${confirmClass}`,
				},
				onOpen: (modalElement) => {
					if (customer === customerConstants.EXO_CUSTOMER2) {
						modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
					}
				}
			})
		}
	}

	onSetMarks = (el, val) => {
		var list = this.state.mark_allocation
		var question_list = this.state.assessmentQuestionsData
		var total = this.state.total
		var question_id = el.question_id
		var index = _.findIndex(question_list, { question_id: question_id })
		if (
			!isNaN(parseFloat(list[question_id])) &&
			parseFloat(list[question_id]) != 0
		) {
			if (parseFloat(question_list[index].mark_allocation)) {
				total = total - parseFloat(question_list[index].mark_allocation)
			}
			total = total + parseFloat(list[question_id])
			question_list[index].mark_allocation = parseFloat(list[question_id])
			this.setState({
				assessmentQuestionsData: question_list,
				total: total,
				changes: true,
			})
		} else if (list[question_id] == "") {
			this.setState({
				assessmentQuestionsData: question_list,
				total: total,
				changes: true,
			})
			list[question_id] =
				this.state.assessmentQuestionsData[index]["mark_allocation"]
			this.setState({
				mark_allocation: list,
			})
			window.Swal.fire({
				title: messageTypes.WARNING,
				text: "Not a Number. Mark allocated will be reverted to previous value.",
				icon: messageTypes.WARNING,
				customClass: {
					confirmButton: `btn font-weight-bold ${confirmClass}`,
				},
				onOpen: (modalElement) => {
					if (customer === customerConstants.EXO_CUSTOMER2) {
						modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
					}
				}
			})
		} else {
			list[question_id] =
				this.state.assessmentQuestionsData[index]["mark_allocation"]
			window.Swal.fire({
				title: messageTypes.WARNING,
				text: "Mark allocated is reverted to previous value.",
				icon: messageTypes.WARNING,
				customClass: {
					confirmButton: `btn font-weight-bold ${confirmClass}`,
				},
				onOpen: (modalElement) => {
					if (customer === customerConstants.EXO_CUSTOMER2) {
						modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
					}
				}
			})
			this.setState({
				mark_allocation: list,
			})
		}
	}

	async onDownloadAttachment(e, attach) {
		e.preventDefault()
		let fileReader;
		async function handleFileRead() {
			const content = fileReader.result;
		}
		fileReader = new FileReader();
		fileReader.onloadend = handleFileRead;
		let containerName = config.storageBlobConfigs.containerName;
		let content = await AzureStorage.downloadBlob(containerName, attach);
		fileReader.readAsArrayBuffer(content);
	}

	addQuestion = () => {
		if (this.state.changes) {
			window.Swal.fire({
				text: "You have unsaved changes in this page. Save them before adding new questions",
				icon: "warning",
				showCancelButton: true,
				buttonsStyling: !1,
				confirmButtonText: "Discard and proceed",
				cancelButtonText: "Stay on page",
				customClass: {
					confirmButton: `btn font-weight-bold ${cancelClass}`,
					cancelButton: `btn font-weight-bold ${confirmClass}`,
				},
				onOpen: (modalElement) => {
					if (customer === customerConstants.EXO_CUSTOMER2) {
						modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
						modalElement.querySelector('.swal2-cancel').setAttribute('id', 'cancelButtonId');
					}
				}
			}).then(async (action) => {
				if (action.isConfirmed) {
					this.props.viewAddQuestions(this.state.assessment);
					this.setState({
						add_question: true,
						mark_allocation: {},
						assessmentQuestionsData: [],
					})
				}
			})
		} else {
			this.props.viewAddQuestions(this.state.assessment);
			this.setState({
				add_question: true,
				mark_allocation: {},
				assessmentQuestionsData: [],
			})
		}
	}

	renderStudentView = async () => {
		this.setState({ isStudentViewLoading: true });
		await this.fetchAllAssessmentQuestions();
		await this.props?.getAllQuestionContents({
			questions: this.props?.assessmentFilteredQuestions,
		});
		this.setState({ isStudentViewLoading: false });
		this.setState({ studentView: true });
	}

	resetAll = () => {
		if (this.state.changes) {
			window.Swal.fire({
				text: "All the unsaved changes will be reverted. Do you want to proceed?",
				icon: "warning",
				showCancelButton: true,
				buttonsStyling: !1,
				confirmButtonText: "Discard and reset",
				cancelButtonText: "Cancel",
				customClass: {
					confirmButton: `btn font-weight-bold ${cancelClass}`,
					cancelButton: `btn font-weight-bold ${confirmClass}`,
				},
				onOpen: (modalElement) => {
					if (customer === customerConstants.EXO_CUSTOMER2) {
						modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
						modalElement.querySelector('.swal2-cancel').setAttribute('id', 'cancelButtonId');
					}
				}
			}).then(async (action) => {
				if (action.isConfirmed) {
					this.fetchAllAssessmentQuestions();
					this.setState({
						deletion: false,
						assessmentQuestionsData: [],
						to_delete: [],
						total: "",
						errors: {},
						mark_allocation: {},
						position_list: {},
						changes: false,
						get_content: true,
						add_question: false,
						searchValue: "",
						selectedCategory: 0,
						selectedType: 0,
						selectedDifficulty: 0,
						chkbox: false,
						filteredQuestions: [],
						selectedQuestion: [],
					})
				}
			})
		}
		else {
			this.fetchAllAssessmentQuestions();
			this.setState({
				deletion: false,
				assessmentQuestionsData: [],
				to_delete: [],
				total: "",
				errors: {},
				mark_allocation: {},
				position_list: {},
				changes: false,
				get_content: true,
				add_question: false,
				searchValue: "",
				selectedCategory: 0,
				selectedType: 0,
				selectedDifficulty: 0,
				chkbox: false,
				filteredQuestions: [],
			})
		}
	}

	getEditability(user_id) {
		var role_permission =
			this.state.assessment["role_code"] == "CASS" ||
			user_id.endsWith(sessionStorage.getItem("user_id"))
		var assessment_state =
			this.state.assessment.assessment_state == "Ready" ||
			this.state.assessment.assessment_state == "Finished" ||
			this.state.assessment.assessment_state == "Review" ||
			this.state.assessment.assessment_state == "InReview" ||
			this.state.assessment.assessment_state == "ReviewCompleted" ||
			this.state.assessment.assessment_state == "Published" ||
			this.state.assessment.assessment_state == "Retired"
		return role_permission && !assessment_state
	}

	getText() {
		if (this.state.assessment.assessment_state == "Initial") {
			return <p style={{ fontSize: "14px" }}>Make sure to click "<b>Save Changes</b>" after doing any modifications to this page!</p>;
		}
		else if (this.state.assessment.assessment_state == "Ready") {
			return <p style={{ fontSize: "14px" }}>Make sure to click "<b>Make Editable</b>" to do any modifications to this page! Click "<b>Set For Review</b>" to set this page under review!</p>;
		}
		else if ((this.state.assessment.assessment_state == "Review") && (["MASAD"].includes(sessionStorage.getItem("employeeType")))) {
			return <p style={{ fontSize: "14px" }}>Make sure to click "<b>Publish</b>" after doing your review to this page! Once published it will go live for students!</p>;
		}
		else if ((this.state.assessment.assessment_state == "Review") && (["DEOP"].includes(sessionStorage.getItem("employeeType")))) {
			return <p style={{ fontSize: "14px" }}>Assessment is Under Review!</p>;
		}
		else if ((this.state.assessment.assessment_state == "Published") && (["MASAD"].includes(sessionStorage.getItem("employeeType")))) {
			return <p style={{ fontSize: "14px" }}>Assessment is published and live for students! You can not do any modifications to this page!</p>;
		}
		else if ((this.state.assessment.assessment_state == "Retired") && (["MASAD"].includes(sessionStorage.getItem("employeeType")))) {
			return <p style={{ fontSize: "14px" }}>Assessment is retired! You can not do any modifications to this page! Please Contact Administrator!</p>;
		}
	}

	getEditabilityAssessment() {
		var assessment_state = this.state.assessment.assessment_state == "Ready" || this.state.assessment.assessment_state == "Finished"
		return !assessment_state
	}

	groupQuestionsByPartAndSection = (questionsList) => {
		const partsMap = {};

		// Step 1: Initialize parts map
		this.state.assessment_parts.forEach((part) => {
			partsMap[part.assessment_part_id] = {
				part_id: part.assessment_part_id,
				assessment_part_id: part.assessment_part_id,
				no_of_sections: part.no_of_sections,
				display_order: part.display_order,
				part_name: part.part_title,
				allow_instruction: part.allow_instruction,
				part_instruction: part.part_instruction,
				sections: [],
			};
		});

		// Step 2: Attach sections to corresponding parts
		this.state.assessment_sections.forEach((section) => {
			const part = partsMap[section.assessment_part_id];
			if (part) {
				part.sections.push({
					...section,
					section_id: section.part_section_id,
					allow_instruction: section.allow_instruction,
					section_instruction: section.section_instruction,
					display_order: section.display_order,
					questions: [],
				});
			}
		});

		// Step 3: Attach questions to the correct section
		questionsList.forEach((question) => {
			if (!question.section_id) return;

			// Find the part that contains this section
			const part = Object.values(partsMap).find((p) =>
				p.sections.some((s) => s.section_id === question.section_id)
			);
			if (part) {
				const section = part.sections.find((s) => s.section_id === question.section_id);
				if (section) {
					section.questions.push(question);
				}
			}
		});

		// Step 4: Convert partsMap to sorted array by part.display_order
		const grouped = Object.values(partsMap)
			.sort((a, b) => a.display_order - b.display_order)
			.map((part) => {
				// Sort sections by section.display_order
				part.sections.sort((a, b) => a.display_order - b.display_order);
				return part;
			});

		return grouped;
	};

	handleOpenSectionModal = (part) => {

		const filteredSections = this.state.assessment_sections.filter(
			section => section.assessment_part_id === part.assessment_part_id
		);

		const defaultNotation = this.state.notations.find(n => n.notation_type === 'Numeric');

		this.setState({
			section_modal: true,
			selected_notation: defaultNotation.notation_id,
			selected_assessment_part: part,
			section_title: '',
			allow_section_instruction: '',
			section_instruction: '',
			allow_optional_questions: false,
			no_of_required_questions: null,
			no_of_questions_to_answer: null,
			section_display_order: filteredSections.length + 1
		});
	}

	handleCloseSectionModal = () => {
		this.setState({ section_modal: false })
	}

	confirmAddSection = async () => {

		const { selected_assessment_part, selected_notation, section_title, allow_section_instruction, section_instruction, section_display_order, assessment, allow_optional_questions, no_of_required_questions, no_of_questions_to_answer } = this.state;

		if (!section_title || !section_display_order || selected_notation === null) {
			this.setState({
				snackbar: {
					message: 'Please fill all required fields!',
					open: true,
					servity: 'error'
				}
			});
			return;
		}

		if (allow_optional_questions) {
			if (!no_of_required_questions || !no_of_questions_to_answer) {
				this.setState({
					snackbar: {
						message: 'Please provide required and answerable question counts!',
						open: true,
						servity: 'error'
					}
				});
				return;
			}
		}

		if (allow_section_instruction) {
			const cleaned = section_instruction
				.split('\n')
				.map(line => line.replace(/^•\s*/, '').trim())
				.filter(line => line.length > 0);

			if (cleaned.length === 0) {
				this.setState({
					snackbar: {
						message: 'Please provide valid section instruction!',
						open: true,
						severity: 'error'
					}
				});
				return;
			}
		}

		if (
			allow_optional_questions &&
			parseInt(no_of_required_questions) >= parseInt(no_of_questions_to_answer)
		) {
			this.setState({
				snackbar: {
					message: 'Number of required questions must be less than number of questions to answer!',
					open: true,
					servity: 'error'
				}
			});
			return;
		}

		this.setState({ add_section_loading: true, section_modal: false })

		const sectionToAdd = {
			assessment_part_id: selected_assessment_part.assessment_part_id,
			section_title: section_title,
			allow_optional_questions: allow_optional_questions,
			no_of_required_questions: allow_optional_questions ? parseInt(no_of_required_questions, 10) : null,
			no_of_questions_to_answer: allow_optional_questions ? parseInt(no_of_questions_to_answer, 10) : null,
			allow_instruction: allow_section_instruction ? allow_section_instruction : false,
			section_instruction: section_instruction,
			display_order: parseInt(section_display_order),
			notation_id: parseInt(selected_notation),
			created_by: DataHandler.getFromSession('manage_user_id')
		};

		const result = await assessmentService.addAssessmentPartSection(sectionToAdd)


		if (result.success && result.data) {

			this.setState(prevState => ({
				assessment_sections: [...(prevState.assessment_sections || []), result.data],
				section_modal: false,
				selected_notation: null,
				selected_assessment_part: null,
				section_title: '',
				allow_section_instruction: '',
				section_instruction: '',
				section_display_order: 0
			}), () => {
				this.setState({ add_section_loading: false }, () => {

					this.setState({
						snackbar: {
							message: 'Section added',
							open: true,
							servity: 'success'
						}
					});

				})
				this.loadAssessmentPartSectionData(this.state.assessment);
			});

		}
		else {
			this.setState({ add_section_loading: false }, () => {

				this.setState({
					snackbar: {
						message: 'Failed to add section',
						open: true,
						servity: 'error'
					}
				});

			})
		}

	};

	handlePartSelection = (part) => {

		this.setState({
			openDialog: true,
			selectedPart: part,
			part_title: '',
			no_of_sections: '',
			allow_part_instruction: '',
			part_instruction: '',
			display_order: this.state.assessment_parts.length + 1
		});
	}

	confirmAddPart = async () => {

		const { selectedPart, part_title, allow_part_instruction, part_instruction, no_of_sections, display_order, assessment } = this.state;

		if (!part_title || !no_of_sections) {
			this.setState({
				snackbar: {
					message: 'Please fill all required fields!',
					open: true,
					servity: 'error'
				}
			});
			return;
		}

		if (allow_part_instruction) {
			const cleaned = part_instruction
				.split('\n')
				.map(line => line.replace(/^•\s*/, '').trim())
				.filter(line => line.length > 0);

			if (cleaned.length === 0) {
				this.setState({
					snackbar: {
						message: 'Please provide valid part instruction!',
						open: true,
						severity: 'error'
					}
				});
				return;
			}
		}

		this.setState({ add_section_loading: true, openDialog: false })

		const partToAdd = {
			part_id: selectedPart.part_id,
			part_title: part_title,
			allow_instruction: allow_part_instruction ? allow_part_instruction : false,
			part_instruction: part_instruction,
			no_of_sections: no_of_sections,
			assessment_id: assessment.assessment_id,
			display_order: parseInt(display_order),
			created_by: DataHandler.getFromSession('manage_user_id')
		};

		const result = await assessmentService.addAssessmentPart(partToAdd)

		if (result.success && result.data) {
			this.setState(prevState => ({
				assessment_parts: [...(prevState.assessment_parts || []), result.data],
				openDialog: false,
				selectedPart: null,
				part_title: '',
				allow_part_instruction: '',
				part_instruction: '',
				no_of_sections: '',
				display_order: ''
			}), () => {
				this.setState({ add_section_loading: false }, () => {

					this.setState({
						snackbar: {
							message: 'Part added',
							open: true,
							servity: 'success'
						}
					});

				})
				this.loadAssessmentPartSectionData(this.state.assessment);
			});
		}
		else {
			this.setState({ add_section_loading: false }, () => {

				this.setState({
					snackbar: {
						message: 'Failed to add part',
						open: true,
						servity: 'error'
					}
				});

			})
		}


	};

	editPart = async (part) => {

		this.setState({ selectedEditPart: part },
			() => {
				this.setState({ openPartEdit: true })
			})

	}

	confirmUpdatePart = async () => {

		const { selectedEditPart, assessment_parts } = this.state;

		if (!selectedEditPart.part_name || !selectedEditPart.no_of_sections) {
			this.setState({
				snackbar: {
					message: 'Please fill all required fields!',
					open: true,
					servity: 'error'
				}
			});
			return;
		}

		if (selectedEditPart.allow_instruction) {
			const cleaned = selectedEditPart.part_instruction
				.split('\n')
				.map(line => line.replace(/^•\s*/, '').trim())
				.filter(line => line.length > 0);

			if (cleaned.length === 0) {
				this.setState({
					snackbar: {
						message: 'Please provide valid part instruction!',
						open: true,
						severity: 'error'
					}
				});
				return;
			}
		}

		this.setState({ update_loading: true });

		const partToUpdate = {
			part_title: selectedEditPart.part_name,
			no_of_sections: selectedEditPart.no_of_sections,
			allow_instruction: selectedEditPart.allow_instruction,
			part_instruction: selectedEditPart.part_instruction,
		};

		try {
			const result = await assessmentService.updatePart(partToUpdate, selectedEditPart.assessment_part_id);

			if (result && result.success) {
				const updatedParts = assessment_parts.map(part =>
					part.assessment_part_id === result.data.assessment_part_id ?
						{ ...part, ...result.data } :
						part
				);

				this.setState({
					update_loading: false,
					assessment_parts: updatedParts,
					openPartEdit: false,
					selectedEditPart: null,
					snackbar: {
						message: 'Part updated',
						open: true,
						servity: 'success'
					}
				});
			} else {
				this.setState({
					update_loading: false,
					snackbar: {
						message: 'Failed to update part',
						open: true,
						servity: 'error'
					}
				});
			}
		} catch (error) {
			console.error("Update failed:", error);
			this.setState({
				update_loading: false,
				snackbar: {
					message: 'Server error during update',
					open: true,
					servity: 'error'
				}
			});
		}
	};

	editSection = async (section) => {

		this.setState({ selectedEditSection: section },
			() => {
				this.setState({ openSectionEdit: true })
			})

	}

	confirmUpdateSection = async () => {

		const { selectedEditSection, assessment_sections } = this.state;

		if (!selectedEditSection.section_title || !selectedEditSection.display_order || selectedEditSection.notation_id === null) {
			this.setState({
				snackbar: {
					message: 'Please fill all required fields!',
					open: true,
					servity: 'error'
				}
			});
			return;
		}

		if (selectedEditSection.allow_optional_questions) {
			if (!selectedEditSection.no_of_required_questions || !selectedEditSection.no_of_questions_to_answer) {
				this.setState({
					snackbar: {
						message: 'Please provide required and answerable question counts!',
						open: true,
						servity: 'error'
					}
				});
				return;
			}
		}

		if (selectedEditSection.allow_instruction) {
			const cleaned = selectedEditSection.section_instruction
				.split('\n')
				.map(line => line.replace(/^•\s*/, '').trim())
				.filter(line => line.length > 0);

			if (cleaned.length === 0) {
				this.setState({
					snackbar: {
						message: 'Please provide valid section instruction!',
						open: true,
						severity: 'error'
					}
				});
				return;
			}
		}

		if (
			selectedEditSection.allow_optional_questions &&
			parseInt(selectedEditSection.no_of_required_questions) >= parseInt(selectedEditSection.no_of_questions_to_answer)
		) {
			this.setState({
				snackbar: {
					message: 'Number of required questions must be less than number of questions to answer!',
					open: true,
					servity: 'error'
				}
			});
			return;
		}

		this.setState({ update_loading: true });

		const sectionToUpdate = {
			section_title: selectedEditSection.section_title,
			notation_id: parseInt(selectedEditSection.notation_id),
			allow_optional_questions: selectedEditSection.allow_optional_questions,
			no_of_required_questions: selectedEditSection.allow_optional_questions ? parseInt(selectedEditSection.no_of_required_questions, 10) : null,
			no_of_questions_to_answer: selectedEditSection.allow_optional_questions ? parseInt(selectedEditSection.no_of_questions_to_answer, 10) : null,
			allow_instruction: selectedEditSection.allow_instruction,
			section_instruction: selectedEditSection.section_instruction,
		};

		try {
			const result = await assessmentService.updateSection(sectionToUpdate, selectedEditSection.part_section_id);

			if (result && result.success) {

				const updatedSections = assessment_sections.map(section =>
					section.part_section_id === result.data.part_section_id
						? { ...section, ...result.data }
						: section
				);


				this.setState({
					assessment_sections: updatedSections,
					update_loading: false,
					openSectionEdit: false,
					selectedEditSection: null,
					snackbar: {
						message: 'Section updated',
						open: true,
						servity: 'success'
					}
				});
				this.loadAssessmentPartSectionData(this.state.assessment);

			} else {
				this.setState({
					update_loading: false,
					snackbar: {
						message: 'Failed to update section',
						open: true,
						servity: 'error'
					}
				});
			}
		} catch (error) {
			this.setState({
				update_loading: false,
				snackbar: {
					message: 'Server error during update',
					open: true,
					servity: 'error'
				}
			});
		}

	}

	validateSectionQuestionLimits = () => {
		const grouped = this.groupQuestionsByPartAndSection(this.state.assessmentQuestionsData);
		const errors = [];

		const isTrue = (val) => val === true || val === "true";
		const isFalse = (val) => val === false || val === "false";

		grouped.forEach(part => {
			const partName = part.part_title || part.part_name || `Part ${part.display_order || ''}`;

			part.sections.forEach(section => {
				const sectionName = section.section_title || 'Unnamed Section';

				const mainQuestions = section.questions.filter(q => q.is_subquestion !== "true");

				const totalQuestions = mainQuestions.length;
				const requiredQuestions = mainQuestions.filter(q => isFalse(q.is_optional)).length;
				const optionalQuestions = mainQuestions.filter(q => isTrue(q.is_optional)).length;

				const minRequired = parseInt(section.no_of_required_questions || 0, 10);
				const toAnswer = parseInt(section.no_of_questions_to_answer || 0, 10);

				const optionalNeeded = toAnswer - minRequired;

				// Validation 1: not enough total questions
				if (totalQuestions < toAnswer) {
					errors.push(`Part "${partName}" → Section "${sectionName}" has only ${totalQuestions} questions but requires ${toAnswer} to answer.`);
				}

				// Validation 2: not enough required questions
				if (requiredQuestions < minRequired) {
					errors.push(`Part "${partName}" → Section "${sectionName}" has only ${requiredQuestions} required questions but needs minimum ${minRequired}.`);
				}

				// Validation 3: required more than to answer
				if (minRequired > toAnswer) {
					errors.push(`Part "${partName}" → Section "${sectionName}" has ${minRequired} required questions but only ${toAnswer} can be answered.`);
				}

				// Validation 4: not enough optional questions for a fair choice
				if (optionalNeeded > 0 && optionalQuestions < optionalNeeded + 1) {
					errors.push(`Part "${partName}" → Section "${sectionName}" needs at least ${optionalNeeded + 1} optional questions for a fair choice, but has only ${optionalQuestions}.`);
				}
			});
		});

		if (errors.length > 0) {
			window.Swal.fire({
				icon: 'error',
				title: 'Validation Error',
				html: errors.map(e => `<div style="text-align:left">${e}</div>`).join(""),
			});
			return false;
		}

		return true;
	};

	synceTableSetupAssessment(showingQuestionsList) {

		const handleDragEnd = async (e) => {
			if (!e.destination) return;

			let tempData = Array.from(this.state.assessmentQuestionsData);
			let [source_data] = tempData.splice(e.source.index, 1);
			tempData.splice(e.destination.index, 0, source_data);

			const newAssessmentQuestions = [...tempData];

			const position_list = {};

			// Update position_list based on the new order
			newAssessmentQuestions.forEach((el, index) => {
				position_list[el.question_id] = index + 1;
			});

			// Update the state asynchronously
			await this.setState({
				assessmentQuestionsData: newAssessmentQuestions,
				position_list: position_list,
			});

			// Trigger onPositionChange after the state is updated
			this.onPositionChange();
			//this.onSave();
		}

		const handleDragEndQuestion = async (result) => {
			const { source, destination } = result;
			if (!destination) return;

			const [sourcePartId, sourceSectionId] = source.droppableId.split("-").map(Number);
			const [destPartId, destSectionId] = destination.droppableId.split("-").map(Number);

			// Clone the original data
			const original = [...this.state.assessmentQuestionsData];

			// Group the original flat list
			const grouped = this.groupQuestionsByPartAndSection(original);

			// Find source and destination sections
			const sourcePart = grouped.find(p => p.part_id === sourcePartId);
			const destPart = grouped.find(p => p.part_id === destPartId);

			const sourceSection = sourcePart?.sections.find(s => s.section_id === sourceSectionId);
			const destSection = destPart?.sections.find(s => s.section_id === destSectionId);

			if (!sourceSection || !destSection) return;

			// Identify if the dragged question is a main question
			const draggedItem = sourceSection.questions[source.index];
			let movedItems = [];

			if (draggedItem.sub_questions !== null) {
				// Main question: collect it + its subquestions
				movedItems.push(draggedItem);

				// Check next items until a non-subquestion or end
				for (let i = source.index + 1; i < sourceSection.questions.length; i++) {
					const q = sourceSection.questions[i];
					if (q.is_subquestion === "true") {
						movedItems.push(q);
					} else {
						break;
					}
				}
			} else {
				// Subquestion or normal: move only one
				movedItems.push(draggedItem);
			}

			// Prevent moving optional questions to disallowed sections
			if (
				sourceSectionId !== destSectionId &&  // <== Only apply if section is changing
				!destSection.allow_optional_questions &&
				movedItems.some(item => item.is_optional === true)
			) {
				window.Swal.fire({
					icon: 'warning',
					title: 'Can not move!',
					text: "Optional questions cannot be moved to a section that doesn't allow them!",
				});
				return;
			}

			// Prevent removing required question if it violates no_of_required_questions
			if (sourceSectionId !== destSectionId) {
				const requiredCount = sourceSection.questions.filter(q => q.is_optional === false).length;
				const numToRemove = movedItems.filter(q => q.is_optional === false).length;
				const remainingRequired = requiredCount - numToRemove;
				const minRequired = sourceSection.no_of_required_questions || 0;

				if (remainingRequired < minRequired) {
					window.Swal.fire({
						icon: 'warning',
						title: 'Invalid Move!',
						text: `This section requires at least ${minRequired} required questions. This move would violate that.`,
					});
					return;
				}
			}

			// Remove items from source section
			sourceSection.questions.splice(source.index, movedItems.length);

			// Update IDs for moved items
			movedItems.forEach(item => {
				item.part_id = destPartId;
				item.section_id = destSectionId;
			});

			// Insert into destination
			destSection.questions.splice(destination.index, 0, ...movedItems);

			// Flatten again
			const flattened = [];
			grouped.forEach(part => {
				part.sections.forEach(section => {
					section.questions.forEach(q => {
						flattened.push(q);
					});
				});
			});

			// Update positions
			const position_list = {};
			flattened.forEach((q, idx) => {
				position_list[q.question_id] = idx + 1;
			});

			await this.setState({
				assessmentQuestionsData: flattened,
				position_list,
			});

			this.onPositionChange();
		};

		return (
			<>
				{(this.state.assessmentQuestionsData && this.state.assessmentQuestionsData.length > 0) || (this.state.assessment_parts.length > 0 || this.state.assessment_sections.length > 0) ? (
					<>
						<div className="col-md-15 d-flex align-items-center mb-5">
							{/* <div className="col-md-6">
								<div className="bg-gray-200 rounded-lg p-2 m-total-marks text-center">
									<h5 className="text-dark font-weight-bold d-block font-size-h5">
										Total Marks
									</h5>
									<h3 className="text-dark font-weight-bold font-size-h5 m-0">
										{this.state.total}
									</h3>
								</div>
							</div> */}
							{/* <div className="col-md-3">
								<input
									type="checkbox"
									id="selectMyQuestions"
									onChange={this.handleSelectMyQuestions}
									checked={this.state.checked}
									style={{ marginRight: '8px' }}  
								/>
								<label htmlFor="selectMyQuestions" style={{ margin: 0, cursor: 'pointer' }}>
									My Questions
								</label>
							</div> */}
							<div className="col-md-6">
								{this.state.assessment.assessment_state == "Initial" && this.state.rowsPerPage >= this.state.assessmentAllQuestionsData.length && (
									<Marks
										viewAllocated={false}
										onChangeMarks={(e) => this.onChangeAllMarks(e)}
										onSetMarks={() => this.onSetAllMarks()}
										viewAllMarks={true}
									/>
								)}
							</div>
						</div>

						{this.state.assessment_parts.length === 0 ? (
							<div className="col-md-12" style={{ overflow: "auto", height: "50vh" }}>
								<DragDropContext onDragEnd={handleDragEnd}>
									<Table>
										<TableHead>
											<TableRow>
												<TableCell className="thead">Drag</TableCell>
												<TableCell className="thead">Question Type</TableCell>
												<TableCell className="thead">Select</TableCell>
												<TableCell className="thead">Question Code</TableCell>
												<TableCell className="thead">Question Title</TableCell>
												<TableCell className="thead">Added By</TableCell>
												<TableCell className="thead">Marks</TableCell>
												<TableCell className="thead">Actions</TableCell>
											</TableRow>
										</TableHead>

										<Droppable droppableId="droppable-1">
											{(provider) => (
												<TableBody
													ref={provider.innerRef}
													{...provider.droppableProps}
												>
													{showingQuestionsList.map((el, i) => (
														<Draggable
															key={el.question_id}
															draggableId={el.answer}
															index={i}
														>
															{(provider) => (
																<TableRow
																	{...provider.draggableProps}
																	ref={provider.innerRef}
																>
																	<TableCell
																		className="tData"
																		{...provider.dragHandleProps}
																	>
																		<b>≡</b>
																	</TableCell>
																	<TableCell>
																		{el.sub_questions !== null ? "Main Question" : el.is_subquestion === "true" ? "Sub Question" : el?.question_type}
																	</TableCell>

																	<TableCell className="tData">
																		{el?.is_subquestion === null && (
																			<div>
																				<input
																					type="checkbox"
																					value={el.question_id}
																					onChange={(e) => this.handleSelectQuestion(e, el)} />
																			</div>
																		)}
																	</TableCell>
																	<TableCell className="tData">
																		{"QUSTN" + el.question_id}
																	</TableCell>
																	<TableCell className="tData">
																		{(i + 1) + ". " + el.title}
																	</TableCell>
																	<TableCell className="tData">
																		{el.first_name.concat(" ", el.last_name)}
																	</TableCell>
																	<TableCell className="tData">
																		{el.sub_questions === null && (
																			<Marks
																				viewAllocated={false}
																				value={this.state.mark_allocation[el.question_id]}
																				onChangeMarks={(e) => this.onChangeMarks(e, el, i)}
																				onSetMarks={() => this.onSetMarks(el, i)}
																				readOnly={!this.getEditability(el.added_by)}
																				question={i} />
																		)}
																	</TableCell>
																	<TableCell className="tData">
																		<Button
																			onClick={(e) => this.onViewFinalizeQuestion(el, e)}
																			className="btn btn-icon action-btn btn-sm m-1 view-question-btn flaticon-eye-icon"
																			dataIndex={i}
																			dataToggle="modal"
																			dataTarget="#view-details"
																			dataBackDrop="static"
																			title="View Details"
																		/>
																		{el.is_subquestion === null && this.getEditability(el.added_by) && (
																			<Button
																				className="btn btn-icon btn-danger btn-sm flaticon-delete"
																				dataIndex={i}
																				title="Delete"
																				onClick={(e) => this.onDelete(e, el)}
																			/>)}
																	</TableCell>
																</TableRow>

															)}
														</Draggable>
													))}
													{provider.placeholder}
												</TableBody>
											)}
										</Droppable>
									</Table>
									{this.state.assessment.no_of_parts >= 0 && <Box className="setup-assessment-add-part-bar" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mb: '15px' }}>
										<SpeedDial
											className="setup-assessment-speed-dial"
											ariaLabel="SpeedDial Add Part"
											icon={<span className="setup-assessment-add-pill">+ Add a Part</span>}
											direction="right"
										>
											{(() => {
												const { part_list, assessment_parts, assessment } = this.state;

												// Filter parts matching the current notation_id
												const partsMatchingNotation = part_list.filter(
													part => part.notation_id === assessment.part_notation_id
												);

												// Exclude parts that have already been added
												const usedPartIds = assessment_parts.map(p => p.part_id);
												const unusedParts = partsMatchingNotation.filter(
													part => !usedPartIds.includes(part.part_id)
												);

												// Limit to remaining number of parts allowed
												const limitRemaining = assessment.no_of_parts - assessment_parts.length;
												const finalPartsToShow = unusedParts.slice(0, limitRemaining);

												if (finalPartsToShow.length === 0) {
													const notationLabel = this.state.notations.find(
														(notation) => notation.notation_id === parseInt(assessment.part_notation_id)
													)?.notation_type;
													return (
														<div style={{ padding: '8px', color: '#6b7280' }}>
															No parts available for notation: <strong>{notationLabel}</strong>.<br />
															Maximum allowed parts: {assessment.no_of_parts}
														</div>
													);
												}

												return finalPartsToShow.map((part) => (
													<SpeedDialAction
														key={part.part_id}
														icon={part.name}
														tooltipTitle={part.name}
														onClick={() => this.handlePartSelection(part)}
														disabled={
															this.state.assessment.assessment_state == "Ready" ||
															this.state.assessment.assessment_state == "Review" ||
															this.state.assessment.assessment_state == "InReview" ||
															this.state.assessment.assessment_state == "ReviewCompleted" ||
															this.state.assessment.assessment_state == "Published" ||
															this.state.assessment.assessment_state == "Retired"
														}
													/>
												));
											})()}
										</SpeedDial>
									</Box>}
								</DragDropContext>
							</div>
						)
							:
							(
								<div className="col-md-12" style={{ overflow: "auto", height: "120vh" }}>
									<DragDropContext onDragEnd={handleDragEndQuestion}>
										{this.groupQuestionsByPartAndSection(this.state.assessmentQuestionsData).map((partGroup) => (
											<div
												key={`part-${partGroup.part_id}`}
												className="mb-4 p-3 rounded"
												style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', boxShadow: '0 1px 2px rgba(15, 23, 42, 0.05)' }}
											>
												{/* Part Title & Edit */}
												<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
													<Typography variant="h5" sx={{ color: '#111827', fontWeight: 700 }}>
														{partGroup.part_name}
													</Typography>
													<IconButton
														onClick={() => this.editPart(partGroup)}
														disabled={['Ready', 'Review', 'InReview', 'ReviewCompleted', 'Published', 'Retired'].includes(this.state.assessment.assessment_state)}
														color="primary"
														size="small"
													>
														<EditIcon />
													</IconButton>
												</Box>

												{/* Part Instructions */}
												{partGroup.allow_instruction && partGroup.part_instruction && (
													<Box className="mb-3" sx={{ pl: 0 }}>
														<ul>
															{partGroup.part_instruction.split('\n').map((line, idx) => (
																line.trim() && (
																	<li key={`part-inst-${idx}`} style={{ marginBottom: '0.3rem' }}>
																		{line.replace(/^\u2022\s*/, '')}
																	</li>
																)
															))}
														</ul>
													</Box>
												)}

												{/* Sections Loop */}
												{partGroup.sections.map((sectionGroup) => (
													<div
														key={`section-${sectionGroup.section_id}`}
														className="mb-3 p-3 rounded"
														style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', boxShadow: '0 1px 2px rgba(15, 23, 42, 0.05)' }}
													>
														{/* Section Title & Edit */}
														<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
															<Typography variant="h6" sx={{ color: '#111827', fontWeight: 600 }}>
																{sectionGroup.section_title}
															</Typography>
															<IconButton
																onClick={() => this.editSection(sectionGroup)}
																disabled={['Ready', 'Review', 'InReview', 'ReviewCompleted', 'Published', 'Retired'].includes(this.state.assessment.assessment_state)}
																color="primary"
																size="small"
															>
																<EditIcon />
															</IconButton>
														</Box>

														{/* Section Instructions */}
														{sectionGroup.allow_instruction && sectionGroup.section_instruction && (
															<Box className="mb-3" sx={{ pl: 0 }}>
																<ul>
																	{sectionGroup.section_instruction.split('\n').map((line, idx) => (
																		line.trim() && (
																			<li key={`section-inst-${idx}`} style={{ marginBottom: '0.3rem' }}>
																				{line.replace(/^\u2022\s*/, '')}
																			</li>
																		)
																	))}
																</ul>
															</Box>
														)}

														{/* Questions Table */}
														<Table className="table table-bordered table-hover">
															<thead>
																<tr>
																	<th>Drag</th>
																	<th>Question Type</th>
																	<th>Select</th>
																	<th>Question Code</th>
																	<th>Question Title</th>
																	<th>Added By</th>
																	<th>Marks</th>
																	<th>Mark as Optional</th>
																	<th>Actions</th>
																</tr>
															</thead>
															<Droppable droppableId={`${partGroup.part_id}-${sectionGroup.section_id}`} type="QUESTION">
																{(provided) => (
																	<tbody ref={provided.innerRef} {...provided.droppableProps}>
																		{sectionGroup.questions.length > 0 ? (
																			sectionGroup.questions.map((el, i) => (
																				<Draggable key={el.question_id} draggableId={String(el.question_id)} index={i}>
																					{(provided) => (
																						<tr ref={provided.innerRef} {...provided.draggableProps}>
																							<td {...(el.is_subquestion === 'true' ? {} : provided.dragHandleProps)}>
																								{el.is_subquestion !== 'true' && <b>≡</b>}
																							</td>
																							<td>{el.sub_questions ? 'Main Question' : el.is_subquestion === 'true' ? 'Sub Question' : el.question_type}</td>
																							<td>
																								{el.is_subquestion === null && (
																									<input
																										type="checkbox"
																										value={el.question_id}
																										onChange={(e) => this.handleSelectQuestion(e, el)}
																									/>
																								)}
																							</td>
																							<td>{'QUSTN' + el.question_id}</td>
																							<td>{`${i + 1}. ${el.title}`}</td>
																							<td>{`${el.first_name} ${el.last_name}`}</td>
																							<td>
																								{el.sub_questions === null && (
																									<Marks
																										viewAllocated={false}
																										value={this.state.mark_allocation[el.question_id]}
																										onChangeMarks={(e) => this.onChangeMarks(e, el, i)}
																										onSetMarks={() => this.onSetMarks(el, i)}
																										readOnly={!this.getEditability(el.added_by)}
																										question={i}
																									/>
																								)}
																							</td>
																							<td className="text-center">
																								{el.is_subquestion === null && (
																									<div className="btn-group btn-group-sm" role="group">
																										<button
																											type="button"
																											className={`btn ${el.is_optional ? 'btn-success' : 'btn-outline-secondary'}`}
																											onClick={() => this.onOptionalChange(el.question_id, true)}
																										>
																											Yes
																										</button>
																										<button
																											type="button"
																											className={`btn ${!el.is_optional ? 'btn-danger' : 'btn-outline-secondary'}`}
																											onClick={() => this.onOptionalChange(el.question_id, false)}
																										>
																											No
																										</button>
																									</div>
																								)}
																							</td>
																							<td>
																								<Button
																									onClick={(e) => this.onViewFinalizeQuestion(el, e)}
																									className="btn btn-icon action-btn btn-sm m-1 view-question-btn flaticon-eye-icon"
																									title="View Details"
																								/>
																								{el.is_subquestion === null && this.getEditability(el.added_by) && (
																									<Button
																										onClick={(e) => this.onDelete(e, el)}
																										className="btn btn-icon btn-danger btn-sm flaticon-delete"
																										title="Delete"
																									/>
																								)}
																							</td>
																						</tr>
																					)}
																				</Draggable>
																			))
																		) : (
																			<tr>
																				<td colSpan="9" className="text-center text-muted">
																					No Questions Added!
																				</td>
																			</tr>
																		)}
																		{provided.placeholder}
																	</tbody>
																)}
															</Droppable>
														</Table>
													</div>
												))}

												{/* Add Section Button */}
												<Box className="setup-assessment-add-section-bar" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mb: 2, flexDirection: 'column' }}>
													<Box sx={{ display: 'flex', alignItems: 'center' }}>
														<Fab
															variant="extended"
															disabled={
																this.state.add_section_loading ||
																this.state.assessment_sections.filter(sec => sec.assessment_part_id === partGroup.part_id).length >= partGroup.no_of_sections ||
																['Ready', 'Review', 'InReview', 'ReviewCompleted', 'Published', 'Retired'].includes(this.state.assessment.assessment_state)
															}
															color="primary"
															aria-label="add-section"
															onClick={() => this.handleOpenSectionModal(partGroup)}
														>
															<AddIcon sx={{ mr: 1 }} />
															Add a Section
														</Fab>
													</Box>
													{this.state.assessment_sections.filter(sec => sec.assessment_part_id === partGroup.part_id).length >= partGroup.no_of_sections && (
														<Typography variant="body2" color="error" sx={{ mt: 1 }}>
															Maximum {partGroup.no_of_sections} sections allowed for this part.
														</Typography>
													)}
												</Box>

												{/* Loading Bar */}
												{this.state.add_section_loading && (
													<Box sx={{ width: '100%' }}>
														<LinearProgress />
													</Box>
												)}
											</div>
										))}
										{/* Add Part Button at bottom */}
										<Box className="setup-assessment-add-part-bar" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mb: '15px' }}>
											<SpeedDial
												className="setup-assessment-speed-dial"
												ariaLabel="SpeedDial Add Part"
												icon={<span className="setup-assessment-add-pill">+ Add a Part</span>}
												direction="right"
											>
												{(() => {
													const { part_list, assessment_parts, assessment } = this.state;

													// Filter parts matching the current notation_id
													const partsMatchingNotation = part_list.filter(
														part => part.notation_id === assessment.part_notation_id
													);

													// Exclude parts that have already been added
													const usedPartIds = assessment_parts.map(p => p.part_id);
													const unusedParts = partsMatchingNotation.filter(
														part => !usedPartIds.includes(part.part_id)
													);

													// Limit to remaining number of parts allowed
													const limitRemaining = assessment.no_of_parts - assessment_parts.length;
													const finalPartsToShow = unusedParts.slice(0, limitRemaining);

													if (finalPartsToShow.length === 0) {
														const notationLabel = this.state.notations.find(
															(notation) => notation.notation_id === parseInt(assessment.part_notation_id)
														)?.notation_type;
														return (
															<div style={{ padding: '8px', color: '#999' }}>
																No parts available for notation: <strong>{notationLabel}</strong>.<br />
																Maximum allowed parts: {assessment.no_of_parts}
															</div>
														);
													}

													return finalPartsToShow.map((part) => (
														<SpeedDialAction
															key={part.part_id}
															icon={part.name}
															// tooltipTitle={part.name}
															onClick={() => this.handlePartSelection(part)}
															disabled={
																this.state.assessment.assessment_state == "Ready" ||
																this.state.assessment.assessment_state == "Review" ||
																this.state.assessment.assessment_state == "InReview" ||
																this.state.assessment.assessment_state == "ReviewCompleted" ||
																this.state.assessment.assessment_state == "Published" ||
																this.state.assessment.assessment_state == "Retired"
															}
														/>
													));
												})()}
											</SpeedDial>
										</Box>
									</DragDropContext>
								</div>
							)}
					</>
				) : (
					// <div className="text-center mb-5 my-10" style={{ height: "90vh" }}>
					// 	<label>No Questions Available!</label>
					// </div>
					<Box className="setup-assessment-add-part-bar" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mb: '15px' }}>
						<SpeedDial
							className="setup-assessment-speed-dial"
							ariaLabel="SpeedDial basic example"
							icon={<span className="setup-assessment-add-pill">+ Add a Part</span>}
							direction='right'

						>
							{this.state.part_list.length > 0 && this.state.part_list?.map((part) => (
								<SpeedDialAction
									key={part.part_id}
									icon={part.name}
									tooltipTitle={part.name}
									onClick={() => this.handlePartSelection(part)}
									disabled={
										this.state.assessment.assessment_state == "Ready" ||
										this.state.assessment.assessment_state == "Review" ||
										this.state.assessment.assessment_state == "InReview" ||
										this.state.assessment.assessment_state == "ReviewCompleted" ||
										this.state.assessment.assessment_state == "Published" ||
										this.state.assessment.assessment_state == "Retired"
									}
								/>
							))}
						</SpeedDial>
					</Box>
				)}


				<Dialog
					open={this.state.section_modal}
					onClose={() => this.handleCloseSectionModal()}
					PaperProps={{ sx: { borderRadius: 2 } }}
				>
					<DialogTitle sx={{ fontWeight: 700, color: 'primary.main' }}>Add Section Details</DialogTitle>
					<DialogContent>
						<TextField
							autoFocus
							margin="dense"
							label="Section Title"
							fullWidth
							variant="standard"
							value={this.state.section_title || ''}
							onChange={(e) => this.setState({ section_title: e.target.value })}
							required
						/>
						<TextField
							margin="dense"
							label="Display Order"
							type="number"
							fullWidth
							variant="standard"
							value={this.state.section_display_order || ''}
							onChange={(e) => this.setState({ section_display_order: e.target.value })}
							disabled
							required
						/>
						<Box sx={{ width: '100%', mb: 2 }}>
							<InputLabel id="notation-select-label">Select Notation</InputLabel>
							<Select
								labelId="notation-select-label"
								id="notation-select"
								fullWidth
								value={parseInt(this.state.selected_notation) || ''}
								onChange={(e) => this.setState({ selected_notation: e.target.value })}
							>
								{this.state.notations.length > 0 &&
									this.state.notations.map((notation) => (
										<MenuItem key={notation.notation_id} value={notation.notation_id}>
											{notation.notation_type}
										</MenuItem>
									))}
							</Select>
						</Box>

						<Box sx={{ width: '100%', mt: 1 }}>
							<FormControlLabel
								control={
									<Checkbox
										checked={this.state.allow_optional_questions || false}
										onChange={(e) => this.setState({ allow_optional_questions: e.target.checked })}
									/>
								}
								label="Allow Optional Questions"
							/>
						</Box>
						{this.state.allow_optional_questions && (
							<>
								<TextField
									margin="dense"
									label="Number of Required Questions"
									type="number"
									fullWidth
									variant="standard"
									value={this.state.no_of_required_questions || ''}
									onChange={(e) => this.setState({ no_of_required_questions: e.target.value })}
									onKeyDown={(e) => {
										// Prevent entering 'e', 'E', '+', '-' and '.' if not needed
										if (['e', 'E', '+', '-'].includes(e.key)) {
											e.preventDefault();
										}
									}}
									required
								/>
								<TextField
									margin="dense"
									label="Number of Questions to Answer"
									type="number"
									fullWidth
									variant="standard"
									value={this.state.no_of_questions_to_answer || ''}
									onChange={(e) => this.setState({ no_of_questions_to_answer: e.target.value })}
									onKeyDown={(e) => {
										// Prevent entering 'e', 'E', '+', '-' and '.' if not needed
										if (['e', 'E', '+', '-'].includes(e.key)) {
											e.preventDefault();
										}
									}}
									required
								/>
							</>
						)}
						<Box sx={{ width: '100%', mt: 1 }}>
							<FormControlLabel
								control={
									<Checkbox
										checked={!!this.state.allow_section_instruction}
										onChange={(e) =>
											this.setState({ allow_section_instruction: e.target.checked ? true : '', section_instruction: e.target.checked ? '• ' : '' })
										}
									/>
								}
								label="Allow Section Instructions"
							/>
						</Box>
						{this.state.allow_section_instruction && (
							<TextField
								margin="dense"
								label="Section Instructions"
								multiline
								fullWidth
								required
								rows={4}
								variant="standard"
								value={this.state.section_instruction}
								onChange={(e) => this.setState({ section_instruction: e.target.value })}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										e.preventDefault();
										const newValue = this.state.section_instruction
											? this.state.section_instruction + '\n• '
											: '• ';
										this.setState({ section_instruction: newValue });
									}
								}}
							/>
						)}
					</DialogContent>
					<DialogActions sx={{ gap: 1, px: 3, pb: 2 }}>
						<Button
							btnName="Cancel"
							title="Cancel"
							className="btn btn-outline-primary"
							inlineStyle={{ borderRadius: "8px" }}
							onClick={() => this.handleCloseSectionModal()}
						/>
						<Button
							btnName="Add"
							title="Add"
							className="btn btn-primary"
							inlineStyle={{ borderRadius: "8px" }}
							onClick={() => this.confirmAddSection()}
							disabled={this.state.add_section_loading}
						/>
					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.openDialog}
					onClose={() => this.setState({ openDialog: false })}
					PaperProps={{ sx: { borderRadius: 2 } }}
				>
					<DialogTitle sx={{ fontWeight: 700, color: 'primary.main' }}>{`Add Part '${this.state.selectedPart?.name}' Details `}</DialogTitle>
					<DialogContent>
						<TextField
							autoFocus
							margin="dense"
							label="Part Title"
							fullWidth
							variant="standard"
							value={this.state.part_title || ''}
							onChange={(e) => this.setState({ part_title: e.target.value })}
							required
						/>
						<TextField
							margin="dense"
							label="Display Order"
							type="number"
							fullWidth
							disabled
							variant="standard"
							value={this.state.display_order || ''}
							onChange={(e) => this.setState({ display_order: e.target.value })}
						/>
						<TextField
							margin="dense"
							label="No of Sections"
							type="number"
							fullWidth
							variant="standard"
							value={this.state.no_of_sections || ''}
							onChange={(e) => this.setState({ no_of_sections: e.target.value })}
							onKeyDown={(e) => {
								// Prevent entering 'e', 'E', '+', '-' and '.' if not needed
								if (['e', 'E', '+', '-'].includes(e.key)) {
									e.preventDefault();
								}
							}}
							required
						/>
						<Box sx={{ width: '100%', mt: 1 }}>
							<FormControlLabel
								control={
									<Checkbox
										checked={!!this.state.allow_part_instruction}
										onChange={(e) =>
											this.setState({ allow_part_instruction: e.target.checked ? true : '', part_instruction: e.target.checked ? '• ' : '' })
										}
									/>
								}
								label="Allow Part Instructions"
							/>
						</Box>
						{this.state.allow_part_instruction && (
							<TextField
								margin="dense"
								label="Part Instructions"
								multiline
								fullWidth
								required
								rows={4}
								variant="standard"
								value={this.state.part_instruction}
								onChange={(e) => this.setState({ part_instruction: e.target.value })}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										e.preventDefault();
										const newValue = this.state.part_instruction
											? this.state.part_instruction + '\n• '
											: '• ';
										this.setState({ part_instruction: newValue });
									}
								}}
							/>
						)}
					</DialogContent>
					<DialogActions sx={{ gap: 1, px: 3, pb: 2 }}>
						<Button
							btnName="Cancel"
							title="Cancel"
							className="btn btn-outline-primary"
							inlineStyle={{ borderRadius: "8px" }}
							onClick={() => this.setState({ openDialog: false })}
						/>
						<Button
							btnName="Add"
							title="Add"
							className="btn btn-primary"
							inlineStyle={{ borderRadius: "8px" }}
							onClick={() => this.confirmAddPart()}
							disabled={this.state.add_section_loading}
						/>
					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.openPartEdit}
					onClose={() => this.setState({ openPartEdit: false })}
					PaperProps={{ sx: { borderRadius: 2 } }}
				>
					<DialogTitle sx={{ fontWeight: 700, color: 'primary.main' }}>{`Update Part '${this.state.selectedEditPart?.part_name}' Details `}</DialogTitle>
					<DialogContent>
						<TextField
							margin="dense"
							label="Part Title"
							fullWidth
							variant="standard"
							value={this.state.selectedEditPart?.part_name || ''}
							onChange={(e) => {
								const value = e.target.value;
								this.setState((prevState) => ({
									selectedEditPart: {
										...(prevState.selectedEditPart || {}),
										part_name: value,
									},
								}));
							}}
							required
						/>

						<TextField
							margin="dense"
							label="Display Order"
							type="number"
							fullWidth
							variant="standard"
							disabled
							value={this.state.selectedEditPart?.display_order || ''}
						/>

						<TextField
							margin="dense"
							label="No of Sections"
							type="number"
							fullWidth
							variant="standard"
							value={this.state.selectedEditPart?.no_of_sections || ''}
							onChange={(e) => {
								const value = e.target.value;
								this.setState((prevState) => ({
									selectedEditPart: {
										...(prevState.selectedEditPart || {}),
										no_of_sections: value,
									},
								}));
							}}
							onKeyDown={(e) => {
								// Prevent entering 'e', 'E', '+', '-' and '.' if not needed
								if (['e', 'E', '+', '-'].includes(e.key)) {
									e.preventDefault();
								}
							}}
							required
						/>
						<Box sx={{ width: '100%', mt: 1 }}>
							<FormControlLabel
								control={
									<Checkbox
										checked={!!this.state.selectedEditPart?.allow_instruction}
										onChange={(e) => {
											const checked = e.target.checked;
											this.setState((prevState) => ({
												selectedEditPart: {
													...(prevState.selectedEditPart || {}),
													allow_instruction: checked,
													part_instruction: checked ? '• ' : '',
												},
											}));
										}}
									/>
								}
								label="Allow Part Instructions"
							/>
						</Box>
						{this.state.selectedEditPart?.allow_instruction && (
							<TextField
								margin="dense"
								label="Part Instructions"
								multiline
								fullWidth
								required
								rows={4}
								variant="standard"
								value={this.state.selectedEditPart?.part_instruction || ''}
								onChange={(e) => {
									const value = e.target.value;
									this.setState((prevState) => ({
										selectedEditPart: {
											...(prevState.selectedEditPart || {}),
											part_instruction: value,
										},
									}));
								}}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										e.preventDefault();
										const currentText = this.state.selectedEditPart?.part_instruction || '';
										const newValue = currentText + '\n• ';
										this.setState((prevState) => ({
											selectedEditPart: {
												...(prevState.selectedEditPart || {}),
												part_instruction: newValue,
											},
										}));
									}
								}}
							/>
						)}
					</DialogContent>
					<DialogActions sx={{ gap: 1, px: 3, pb: 2 }}>
						{this.state.update_loading ?
							<Backdrop
								sx={(theme) => ({ color: '#fff', zIndex: 3 })}
								open={this.state.update_loading}
							>
								<CircularProgress color="inherit" />
							</Backdrop>
							:
							<>
								<Button
									btnName="Cancel"
									title="Cancel"
									className="btn btn-outline-primary"
									inlineStyle={{ borderRadius: "8px" }}
									onClick={() => this.setState({ openPartEdit: false, selectedEditPart: null })}
								/>
								<Button
									btnName="Update"
									title="Update"
									className="btn btn-primary"
									inlineStyle={{ borderRadius: "8px" }}
									onClick={() => this.confirmUpdatePart()}
								/>
							</>
						}

					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.openSectionEdit}
					onClose={() => this.setState({ openSectionEdit: false })}
					PaperProps={{ sx: { borderRadius: 2 } }}
				>
					<DialogTitle sx={{ fontWeight: 700, color: 'primary.main' }}>{`${this.state.selectedEditSection?.section_title}`}</DialogTitle>
					<DialogContent>
						<TextField
							margin="dense"
							label="Section Title"
							fullWidth
							variant="standard"
							value={this.state.selectedEditSection?.section_title || ''}
							onChange={(e) => {
								const value = e.target.value;
								this.setState((prevState) => ({
									selectedEditSection: {
										...(prevState.selectedEditSection || {}),
										section_title: value,
									},
								}));
							}}
						/>
						<TextField
							margin="dense"
							label="Display Order"
							type="number"
							fullWidth
							variant="standard"
							value={this.state.selectedEditSection?.display_order || ''}
							onChange={(e) => {
								const value = e.target.value;
								this.setState((prevState) => ({
									selectedEditSection: {
										...(prevState.selectedEditSection || {}),
										display_order: value,
									},
								}));
							}}
							disabled
							required
						/>
						<Box sx={{ width: '100%', mb: 2 }}>
							<InputLabel id="notation-select-label">Select Notation</InputLabel>
							<Select
								labelId="notation-select-label"
								id="notation-select"
								fullWidth
								value={parseInt(this.state.selectedEditSection?.notation_id) || ''}
								onChange={(e) => {
									const value = e.target.value;
									this.setState((prevState) => ({
										selectedEditSection: {
											...(prevState.selectedEditSection || {}),
											notation_id: value,
										},
									}));
								}}
							>
								{this.state.notations.length > 0 &&
									this.state.notations.map((notation) => (
										<MenuItem key={notation.notation_id} value={notation.notation_id}>
											{notation.notation_type}
										</MenuItem>
									))}
							</Select>
						</Box>

						<Box sx={{ width: '100%', mt: 1 }}>
							<FormControlLabel
								control={
									<Checkbox
										checked={this.state.selectedEditSection?.allow_optional_questions || false}
										onChange={(e) => {
											const value = e.target.checked;
											const section = this.state.selectedEditSection;

											// Check if disabling and there are optional questions
											if (!value && section?.questions?.some(q => q.is_optional === true)) {
												this.setState({
													snackbar: {
														message: "This section contains optional questions.Please remove or update them before disabling optional support!",
														open: true,
														servity: 'error'
													}
												});
												return; // Block the change
											}

											// Allow change
											this.setState((prevState) => ({
												selectedEditSection: {
													...(prevState.selectedEditSection || {}),
													allow_optional_questions: value,
												},
											}));
										}}
									/>
								}
								label="Allow Optional Questions"
							/>
						</Box>
						{this.state.selectedEditSection?.allow_optional_questions && (
							<>
								<TextField
									margin="dense"
									label="Number of Required Questions"
									type="number"
									fullWidth
									variant="standard"
									value={this.state.selectedEditSection?.no_of_required_questions || ''}
									onChange={(e) => {
										const value = e.target.value;
										this.setState((prevState) => ({
											selectedEditSection: {
												...(prevState.selectedEditSection || {}),
												no_of_required_questions: value,
											},
										}));
									}}
									onKeyDown={(e) => {
										// Prevent entering 'e', 'E', '+', '-' and '.' if not needed
										if (['e', 'E', '+', '-'].includes(e.key)) {
											e.preventDefault();
										}
									}}
									required
								/>
								<TextField
									margin="dense"
									label="Number of Questions to Answer"
									type="number"
									fullWidth
									variant="standard"
									value={this.state.selectedEditSection?.no_of_questions_to_answer || ''}
									onChange={(e) => {
										const value = e.target.value;
										this.setState((prevState) => ({
											selectedEditSection: {
												...(prevState.selectedEditSection || {}),
												no_of_questions_to_answer: value,
											},
										}));
									}}
									onKeyDown={(e) => {
										// Prevent entering 'e', 'E', '+', '-' and '.' if not needed
										if (['e', 'E', '+', '-'].includes(e.key)) {
											e.preventDefault();
										}
									}}
									required
								/>
							</>
						)}
						<Box sx={{ width: '100%', mt: 1 }}>
							<FormControlLabel
								control={
									<Checkbox
										checked={!!this.state.selectedEditSection?.allow_instruction}
										onChange={(e) => {
											const checked = e.target.checked;
											this.setState((prevState) => ({
												selectedEditSection: {
													...(prevState.selectedEditSection || {}),
													allow_instruction: checked,
													section_instruction: checked ? '• ' : '',
												},
											}));
										}}
									/>
								}
								label="Allow Section Instructions"
							/>
						</Box>
						{this.state.selectedEditSection?.allow_instruction && (
							<TextField
								margin="dense"
								label="Section Instructions"
								multiline
								fullWidth
								required
								rows={4}
								variant="standard"
								value={this.state.selectedEditSection?.section_instruction || ''}
								onChange={(e) => {
									const value = e.target.value;
									this.setState((prevState) => ({
										selectedEditSection: {
											...(prevState.selectedEditSection || {}),
											section_instruction: value,
										},
									}));
								}}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										e.preventDefault();
										const currentText = this.state.selectedEditSection?.section_instruction || '';
										const newValue = currentText + '\n• ';
										this.setState((prevState) => ({
											selectedEditSection: {
												...(prevState.selectedEditSection || {}),
												section_instruction: newValue,
											},
										}));
									}
								}}
							/>
						)}
					</DialogContent>
					<DialogActions sx={{ gap: 1, px: 3, pb: 2 }}>
						{this.state.update_loading ?
							<Backdrop
								sx={(theme) => ({ color: '#fff', zIndex: 3 })}
								open={this.state.update_loading}
							>
								<CircularProgress color="inherit" />
							</Backdrop>
							:
							<>
								<Button
									btnName="Cancel"
									title="Cancel"
									className="btn btn-outline-primary"
									inlineStyle={{ borderRadius: "8px" }}
									onClick={() => this.setState({ openSectionEdit: false, selectedEditSection: null })}
								/>
								<Button
									btnName="Update"
									title="Update"
									className="btn btn-primary"
									inlineStyle={{ borderRadius: "8px" }}
									onClick={() => this.confirmUpdateSection()}
								/>
							</>
						}

					</DialogActions>
				</Dialog>



			</>
		)
	}

	//New Multi Filter
	onSelectFilterMulti = (selectedItem) => {

		const { filterValues } = this.state;

		let updatedFilterValues = [...filterValues];

		const index = updatedFilterValues.findIndex(
			(item) =>
				item.filter === selectedItem.filter &&
				item[`${selectedItem.filter.toLowerCase()}_id`] === selectedItem[`${selectedItem.filter.toLowerCase()}_id`]
		);


		if (index === -1) {

			updatedFilterValues.push(selectedItem);

		} else {

			updatedFilterValues.splice(index, 1);
		}


		this.onSelectFilterMultiProcess(updatedFilterValues);
	};

	onSelectFilterMultiProcess = (filterValues) => {

		const filterMap = {
			Category: [],
			Source: [],
			Difficulty: [],
			Language: [],
			Subject: [],
			Author: [],
			Year: [],
			Term: [],
			Chapter: [],
			Grade: [],
			Type: [],
			Created_By: []
		};

		filterValues.forEach((val) => {
			const filterType = val.filter;
			if (filterType && filterMap.hasOwnProperty(filterType)) {
				switch (filterType) {
					case "Category":
						filterMap.Category.push(val?.category_id);
						break;
					case "Source":
						filterMap.Source.push(val?.source_id);
						break;
					case "Difficulty":
						filterMap.Difficulty.push(val?.difficulty_id);
						break;
					case "Language":
						filterMap.Language.push(val?.language_id);
						break;
					case "Subject":
						filterMap.Subject.push(val?.subject_id);
						break;
					case "Author":
						filterMap.Author.push(val?.author_id);
						break;
					case "Year":
						filterMap.Year.push(val?.year_id);
						break;
					case "Term":
						filterMap.Term.push(val?.term_id);
						break;
					case "Chapter":
						filterMap.Chapter.push(val?.chapter_id);
						break;
					case "Grade":
						filterMap.Grade.push(val?.grade_id);
						break;
					case "Type":
						filterMap.Type.push(val?.type_id);
						break;
					case "Created_By":
						filterMap.Created_By.push(val?.created_by_id);
						break;
					default:
						break;
				}
			}
		});

		this.setState(
			{
				filterValues,
				selectedAuthors: filterMap.Author.length > 0 ? filterMap.Author : null,
				selectedsubjects: filterMap.Subject.length > 0 ? filterMap.Subject : null,
				selectedChapters: filterMap.Chapter.length > 0 ? filterMap.Chapter : null,
				selectedTerms: filterMap.Term.length > 0 ? filterMap.Term : null,
				selectedCategories: filterMap.Category.length > 0 ? filterMap.Category : null,
				selectedYears: filterMap.Year.length > 0 ? filterMap.Year : null,
				selectedLanguages: filterMap.Language.length > 0 ? filterMap.Language : null,
				selectedDifficulties: filterMap.Difficulty.length > 0 ? filterMap.Difficulty : null,
				selectedGrades: filterMap.Grade.length > 0 ? filterMap.Grade : null,
				selectedTypes: filterMap.Type.length > 0 ? filterMap.Type : null,
				selectedSources: filterMap.Source.length > 0 ? filterMap.Source : null,
				selectedTeachers: filterMap.Created_By.length > 0 ? filterMap.Created_By : null
			},
			() => {
				this.fetchAllAssessmentQuestions();
			}
		);
	};

	isParentChecked = (filterType) => {
		const filterValues = this.state.filterValues;
		const childItems = this.getChildItems(filterType);
		return (
			childItems.length > 0 &&
			childItems.every((child) =>
				filterValues.some(
					(selectedItem) =>
						selectedItem.filter === filterType &&
						selectedItem[`${filterType.toLowerCase()}_id`] ===
						child[`${filterType.toLowerCase()}_id`]
				)
			)
		);
	};

	isParentIndeterminate = (filterType) => {
		const filterValues = this.state.filterValues;
		const childItems = this.getChildItems(filterType);
		const selectedCount = childItems.filter((child) =>
			filterValues.some(
				(selectedItem) =>
					selectedItem.filter === filterType &&
					selectedItem[`${filterType.toLowerCase()}_id`] ===
					child[`${filterType.toLowerCase()}_id`]
			)
		).length;
		return selectedCount > 0 && selectedCount < childItems.length;
	};

	handleParentCheckboxChange = (filterType, filterItems) => {
		const filterValues = [...this.state.filterValues];
		const childItems = filterItems

		const allSelected = this.isParentChecked(filterType);


		let updatedFilterValues;
		if (allSelected) {

			updatedFilterValues = filterValues.filter(
				(item) => item.filter !== filterType
			);
		} else {

			const newSelections = childItems.map((child) => ({
				filter: filterType,
				name: child.name,
				[`${filterType.toLowerCase()}_id`]: child[`${filterType.toLowerCase()}_id`],
			}));
			updatedFilterValues = [
				...filterValues.filter((item) => item.filter !== filterType),
				...newSelections,
			];
		}


		this.onSelectFilterMultiProcess(updatedFilterValues);
	};

	getChildItems = (filterType) => {
		switch (filterType) {
			case "Category":
				return this.state.allCategories || [];
			case "Source":
				return this.state.allSources || [];
			case "Difficulty":
				return this.state.allDifficulties || [];
			case "Language":
				return this.state.allLanguages || [];
			case "Subject":
				return this.state.allSubjects || [];
			case "Author":
				return this.state.allAuthors || [];
			case "Year":
				return this.state.allYears || [];
			case "Grade":
				return this.state.allGrades || [];
			case "Term":
				return this.state.allTerms || [];
			case "Chapter":
				return this.state.allChapters || [];
			case "Type":
				return this.state.allTypes || [];
			case "Created_By":
				return this.state.allCreators || [];
			default:
				return [];
		}
	};

	clearAllFilters = () => {
		this.setState(
			{
				filterValues: [],
				selectedAuthors: null,
				selectedsubjects: null,
				selectedChapters: null,
				selectedTerms: null,
				selectedCategories: null,
				selectedYears: null,
				selectedLanguages: null,
				selectedDifficulties: null,
				selectedTypes: null,
				selectedSources: null,
				selectedGrades: null,
				selectedTeachers: null
			},
			() => {
				this.fetchAllAssessmentQuestions();
			}
		);
	};

	handleFilterChange = (newSelectedFilters) => {

		const getOrNull = (key) =>
			newSelectedFilters[key] && newSelectedFilters[key].length > 0
				? newSelectedFilters[key]
				: null;

		this.setState(
			{

				selectedCategories: getOrNull("Category"),
				selectedAuthors: getOrNull("Author"),
				selectedChapters: getOrNull("Chapter"),
				selectedGrades: getOrNull("Grade"),
				selectedDifficulties: getOrNull("Difficulty"),
				selectedLanguages: getOrNull("Language"),
				selectedTerms: getOrNull("Term"),
				selectedYears: getOrNull("Year"),
				selectedsubjects: getOrNull("Subject"),
				selectedSources: getOrNull("Source"),
				selectedTypes: getOrNull("Type"),
				selectedStartDate: getOrNull("StartDate"),
				selectedEndDate: getOrNull("EndDate"),
				selectedTeachers: getOrNull("Created_By"),

				offset: 0,
				currentPage: 0,

			},
			() => {
				this.fetchAllAssessmentQuestions();
			}
		);
	};

	handleStartDateChange = (event) => {
		const date = event.target.value;
		const formattedDate = date ? date.replace(/-/g, "") : null;
		this.setState({ selectedStartDate: formattedDate },
			() => {
				this.fetchAllAssessmentQuestions();
			}
		)
	};

	handleEndDateChange = (event) => {
		const date = event.target.value;
		const formattedDate = date ? date.replace(/-/g, "") : null;
		this.setState({ selectedEndDate: formattedDate },
			() => {
				this.fetchAllAssessmentQuestions();;
			}
		)
	};

	clearDateRange = () => {
		this.setState({ selectedStartDate: "", selectedEndDate: "" },
			() => {
				this.setState({ selectedStartDate: null, selectedEndDate: null },
					() => {
						this.fetchAllAssessmentQuestions();
					}
				);
			}
		);
	};

	handlePageChange = (event, newPage) => {
		const { rowsPerPage } = this.state;
		const newOffset = newPage * rowsPerPage;
		this.setState(
			{
				limit: rowsPerPage,
				offset: newOffset,
				isTableDataLoading: true,
				currentPage: newPage,
			},
			() => {
				this.fetchAllAssessmentQuestions();
			}
		);
	};

	handlePageOffsetChange = (newOffset, newPage) => {
		this.setState(
			{
				offset: newOffset,
				isTableDataLoading: true,
				currentPage: newPage
			},
			() => {
				this.fetchAllAssessmentQuestions();
			}
		);
	};

	//handle the data fetching as per the data per page limit gets changes
	handleRowsPerPageChange = (event) => {
		const newLimit = parseInt(event.target.value, 10);
		const { mark_allocation, changes } = this.state;
		this.setState({ rowsPerPage: newLimit });
		const newPage = Math.floor(this.state.offset / newLimit);
		this.setState(
			{
				limit: newLimit,
				offset: newLimit * newPage,
				isTableDataLoading: true,
				currentPage: newPage,
				mark_allocation: mark_allocation,
				changes: changes
			},
			() => {
				this.fetchAllAssessmentQuestions();
			}
		);
	};

	handleSortChange = (sort_column) => {
		// If the same column is clicked, toggle the sort direction
		const { sort_column: currentSortColumn, sort_direction } = this.state;
		const newSortDirection =
			currentSortColumn === sort_column && sort_direction === "ASC"
				? "DESC"
				: "ASC";

		this.setState(
			{
				sort_column,
				sort_direction: newSortDirection,
				offset: 0, // Reset offset when changing sorting
				currentPage: 0,
				isTableDataLoading: true,
			},
			() => {
				this.fetchAllAssessmentQuestions();
			}
		);
	};

	handleSearch = (event) => {
		const limit = this.state.limit;
		const offset = this.state.offset;
		const search_term = event.target.value.trim();
		//const regex = /^[\w\s\d@&.,:;!?()\-_/\\[\]{}'"|#*~+=%$^<>]*$/;
		const regex = /^[\p{L}\p{M}\p{N}\p{P}\p{S}\s]*$/u;

		if (search_term !== "") {
			this.setState({ limit: this.props.totalFilteredCount });
		}

		if (search_term === "" || regex.test(search_term)) {
			this.setState(
				{
					limit,
					offset,
					search_term,
					// isTableDataLoading: true,
					offset: 0,
					currentPage: 0,
					searchError: false,
				},
				() => {
					// Call the debounced version of fetchStudentData
					// this.debouncedHandleSearch();
					// this.fetchAllAssessmentQuestions();
				}
			);
		}
		else {
			this.setState({ search_term, searchError: true });
		}
	};

	handleCloseSnackbar = () => {
		this.setState(prevState => ({
			snackbar: {
				messages: '',
				open: false,
				severity: ''
			}
		}));
	};

	toggleFilterPanelVisibility = () => {
		this.setState((prevState) => ({
			isFilterPanelVisible: !prevState.isFilterPanelVisible,
		}));
	};


	render() {
		if (this.state.add_question) {
			return <Redirect to={routes.finalize_new_question} />
		}
		if (this.state.studentView) {
			return <Redirect to={routes.student_view} />;
		}

		const { isActionLoading } = this.state;
		
		return (
			<AdminTemplate>
				<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isActionLoading}>
					<CircularProgress color="inherit" />
				</Backdrop>

				<ContentWrapper>
					<div className="setup-assessment-page">
						{this.state.isStudentViewLoading && <Spinner id="show" text="Loading Student View.." />}
						{this.state.addPartSectionLoading && <Spinner id="show" text="Please wait.." />}
						{this.state.QusLoding && <Spinner id="show" text="Loading Questions.." />}
						{this.state.assessment.title != undefined ? (
							<Card>

								<CardHeader>
									<CardTitle cardLabel={this.state.assessment.title}>
										<Breadcrumb>
											<BreadcrumbItem
												to={routes.view_assessment}
												breadcrumbItemName="Go Back to Assessments Library"
											/>
											{/* <BreadcrumbItem
                                    to={routes.setup_assessment}
                                    active="active"
                                    breadcrumbItemName="Finalize"
                                /> */}
										</Breadcrumb>
									</CardTitle>

									<CardToolbar>
										<Button
											onClick={() => this.addQuestion()}
											btnName="Add new question"
											className="btn btn-primary mr-2 finalize-btn"
											title="Add new question"
											disabled={
												this.state.assessment.assessment_state == "Ready" ||
												this.state.assessment.assessment_state == "Review" ||
												this.state.assessment.assessment_state == "InReview" ||
												this.state.assessment.assessment_state == "ReviewCompleted" ||
												this.state.assessment.assessment_state == "Published" ||
												this.state.assessment.assessment_state == "Retired"
											}
										/>
										<Button
											className="btn btn-danger btn-mr font-weight-bold mr-2 remove"
											btnName="Delete"
											// btnIconStyle="flaticon-trash"
											onClick={() => this.handleDeleteSelectedQuestions()}
											disabled={
												this.state.assessment.assessment_state == "Ready" ||
												this.state.assessment.assessment_state == "Review" ||
												this.state.assessment.assessment_state == "InReview" ||
												this.state.assessment.assessment_state == "ReviewCompleted" ||
												this.state.assessment.assessment_state == "Published" ||
												this.state.assessment.assessment_state == "Retired"
											}
										/>
										<Button
											onClick={() => this.resetAll()}
											className="btn btn-primary finalize-btn mr-2"
											btnName="Reset"
											disabled={
												this.state.assessment.assessment_state == "Ready" ||
												this.state.assessment.assessment_state == "Review" ||
												this.state.assessment.assessment_state == "InReview" ||
												this.state.assessment.assessment_state == "ReviewCompleted" ||
												this.state.assessment.assessment_state == "Published" ||
												this.state.assessment.assessment_state == "Retired"
											}
										/>
										<Button
											onClick={() => this.renderStudentView()}
											className="btn btn-primary finalize-btn mr-2"
											btnName="Student View"
										/>
										<Button
											className="btn btn-primary mr-2 finalize-btn"
											btnName="Save Changes"
											onClick={this.onSave}
											disabled={
												this.state.assessment.assessment_state == "Ready" ||
												this.state.assessment.assessment_state == "Review" ||
												this.state.assessment.assessment_state == "InReview" ||
												this.state.assessment.assessment_state == "ReviewCompleted" ||
												this.state.assessment.assessment_state == "Published" ||
												this.state.assessment.assessment_state == "Retired"
											}
										/>
										{/* <Button
										className="btn btn-primary mr-2 finalize-btn"
										btnName="Back"
										onClick={() => window.location.href = "/assessments-library"}
										/> */}
										{this.state.assessment["role_code"] == "CASS" && (this.state.assessment.assessment_state == "Initial" || this.state.assessment.assessment_state == "ReferBack") && (
											<Button
												className="btn btn-primary mr-2 finalize-btn"
												btnName="Finalize"
												btnIconStyle="flaticon2-correct"
												onClick={this.finalizeAssessment}
												disabled={(this.state.disabled || this.state.assessment.assessment_state === "ReviewCompleted" || this.state.assessment.assessment_state === "Ready")}
											/>
										)}
										{this.state.assessment["role_code"] == "CASS" && (this.state.assessment["assessment_state"] === "Review" || this.state.assessment.assessment_state == "InReview" || this.state.assessment["assessment_state"] === "ReviewCompleted" || this.state.assessment["assessment_state"] === "ReadyToPublish") &&
											(!["DEOP", "TEACH"].includes(sessionStorage.getItem("employeeType"))) && (
												<Button
													className="btn btn-primary mr-2 finalize-btn"
													btnName="Publish"
													btnIconStyle="flaticon2-correct"
													onClick={this.publishAssessment}
													disabled={this.state.disabled || this.state.assessment["assessment_state"] === "Initial"}
												/>
											)}
										{this.state.assessment["role_code"] == "CASS" && this.state.assessment["assessment_state"] == "Published" && (!["DEOP", "TEACH"].includes(sessionStorage.getItem("employeeType"))) && (
											<Button
												className="btn btn-primary mr-2 finalize-btn"
												btnName="Retire"
												btnIconStyle="flaticon2-correct"
												onClick={this.retireAssessment}
												disabled={this.state.disabled}
											/>
										)}
										{this.state.assessment["role_code"] == "CASS" && (this.state.assessment["assessment_state"] == "Published" || this.state.assessment["assessment_state"] == "Retired") && (!["DEOP", "TEACH"].includes(sessionStorage.getItem("employeeType"))) && (
											<Button
												className="btn btn-primary mr-2 finalize-btn"
												btnName="Make Ready to Publish"
												btnIconStyle="flaticon2-correct"
												onClick={this.unpublishAssessment}
												disabled={this.state.disabled}
											/>
										)}
										{this.state.assessment["role_code"] == "CASS" && this.state.assessment["assessment_state"] == "Ready" && (
											<Button
												className="btn btn-primary mr-2 finalize-btn"
												btnName="Make editable"
												btnIconStyle="flaticon2-correct"
												onClick={this.makeEditableAssessment}
												disabled={this.state.disabled}
											/>
										)}
										{/* {this.state.assessment["role_code"] == "CASS" && this.state.assessment["assessment_state"] == "Ready" && (
										<Button
											className="btn btn-primary mr-2 finalize-btn"
											btnName="Set for review"
											btnIconStyle="flaticon2-correct"
											onClick={this.setForReviewAssessment}
											disabled={this.state.disabled}
										/>
									)} */}
										{/* {this.state.assessment["role_code"] == "CASS" && (this.state.assessment["assessment_state"] == "Review" || this.state.assessment.assessment_state == "InReview" || this.state.assessment["assessment_state"] == "ReviewCompleted") &&
										(!["DEOP", "TEACH"].includes(sessionStorage.getItem("employeeType"))) && (
										<Button
											className="btn btn-primary mr-2 finalize-btn"
											btnName="Make ready"
											btnIconStyle="flaticon2-correct"
											onClick={this.makeReadyAssessment}
											disabled={this.state.disabled || ["DEOP"].includes(sessionStorage.getItem("employeeType"))}
										/>
									)} */}
										{/* to activate print button */}
										{/* {this.state.assessment["assessment_state"] == "Ready" && (
                                <Button
                                    className="btn btn-primary mr-2 finalize-btn"
                                    btnName="Print"
                                    onClick={() => this.handlePrint()}
                                />
                                )} */}

										<div style={{ width: "10px" }}></div>
										{/* to autoshuffle checkBox */}
										{this.state.assessment["assessment_state"] == "Initial" && this.checkingForAllMcqs() && (
											<CheckBoxInline>
												<CheckBox
													checkBoxName="Autoshuffle MCQ"
													onChange={() => this.handleAutoShuffle()}
												/>
											</CheckBoxInline>
										)}
									</CardToolbar>
								</CardHeader>
								{!(this.state.assessment.assessment_state == "ReviewCompleted" || "ReferBack") &&
									<div
										className="row mx-3 my-5 d-flex justify-content-center align-items-center setup-assessment-surface"
										style={{ borderLeft: "4px solid #111827" }}
									>
										<div className="py-5 col-md-3 col-3 d-flex justify-content-end align-items-center">
											<TipsAndUpdatesIcon sx={{ fontSize: "40px", color: "#111827" }} />
										</div>
										<div className="py-5 col-md-9 col-9 d-flex align-items-center">
											{this.getText()}
										</div>
									</div>
								}
								<CardBody>
									{/*old filter */}
									{/*	 <div className="row align-items-center">
									<div className="col-md-12 px-0 filterBySec">
										<Accordion className="filterAccordion">
											<AccordionSummary className="filterAccordionSummary" aria-controls="panel1-content" id="panel1-header">
												<Box
													sx={{ display: "flex", alignItems: "center", gap: "16px" }}
												>
													<div className="filterpprs mr-5">
														<TuneRoundedIcon />
														&emsp;Filter&emsp;
														<KeyboardArrowDownIcon
															sx={{
																transition: "transform 0.3s ease",
																cursor: "pointer",
															}}
															onClick={(e) => { }}
														/>
													</div>
												</Box>
                                               
												<Tooltip title="Clear dates">
													<IconButton onClick={() => this.clearDateRange()}>
														<DeleteForeverRoundedIcon />
													</IconButton>
												</Tooltip>
                                               
												 <span class="badge badge-custom mr-5" style={{ fontSize: '1rem' }}>
													No of Questions:{" "}
													<strong>
														{this.state.isTableDataLoading ?
															(
																<CircularProgress size={16} />
															) : (
																this.props.totalRealFilteredCount
															)
														}
													</strong>
												</span> 

												{this.state.assessment_parts.length > 0 && this.state.assessment["role_code"] == "CASS" && (
													<Button
														className="btn btn-primary mr-2"
														btnName="Update Question Part/Section"
														btnIconStyle="flaticon-add"
														onClick={() => this.setState({ showAddQuestionsModal: true })}
														disabled={
															this.state.assessment.assessment_state == "Ready" ||
															this.state.assessment.assessment_state == "Review" ||
															this.state.assessment.assessment_state == "InReview" ||
															this.state.assessment.assessment_state == "ReviewCompleted" ||
															this.state.assessment.assessment_state == "Published" ||
															this.state.assessment.assessment_state == "Retired"
														}
													/>
												)}

											</AccordionSummary>
											<div className="d-flex align-items-center ml-5 mt-2">
												<div
													key={`part-${partGroup.part_id}`}
													className="mb-4 p-3 rounded"
													style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb' }}
												>
														onChange={this.handleStartDateChange}
														style={{ padding: "5px", marginRight: "10px", borderRadius: "4px" }}
													/>

												</div>

												<div className='mr-2'>
													End Date&nbsp;:&nbsp;{" "}
													<input
														type="date"
														value={this.state.selectedEndDate?.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")}
														onChange={this.handleEndDateChange}
														style={{ padding: "5px", borderRadius: "4px" }}
													/>

												</div>
											</div>
											<Box className="filterCardContainer" sx={{ overflowX: "auto", whiteSpace: "nowrap", display: "flex", padding: "8px", height: '40vh' }}>

												{FILTERS.filter((category) => {

													return ["Grade", "Subject", "Language", "Chapter", "Year", "Term", "Category", "Difficulty", "Type", "Source", "Author"].includes(category);

												}).map((category, index) => {

													let filterItems = [];
													if (category === "Category") {
														const categoryCountsMap = new Map(this.props.categoryCounts.map(([category_id, count]) => [category_id, count]));
														filterItems = this.state.allCategories?.map((val) => ({
															filter: "Category",
															name: val.name,
															category_id: val.category_id,
															dynamic_count: categoryCountsMap.get(val.category_id) || 0,
														}));
													} else if (category === "Type") {
														const typeCountsMap = new Map(this.props.typeCounts.map(([type_id, count]) => [type_id, count]));
														filterItems = this.state.allTypes?.map((val) => ({
															filter: "Type",
															name: val.qtype,
															type_id: val.type_id,
															dynamic_count: typeCountsMap.get(val.type_id) || 0,
														}));
													} else if (category === "Difficulty") {
														const difficultyCountsMap = new Map(this.props.difficultyCounts.map(([difficulty_id, count]) => [difficulty_id, count]));
														filterItems = this.state.allDifficulties?.map((val) => ({
															filter: "Difficulty",
															name: val.difficulty_type,
															difficulty_id: val.difficulty_id,
															dynamic_count: difficultyCountsMap.get(val.difficulty_id) || 0,
														}));
													} else if (category === "Language") {
														const languageCountsMap = new Map(this.props.languageCounts.map(([language_id, count]) => [language_id, count]));
														filterItems = this.state.allLanguages?.map((val) => ({
															filter: "Language",
															name: val.language,
															language_id: val.language_id,
															dynamic_count: languageCountsMap.get(val.language_id) || 0,
														}));
													} else if (category === "Subject") {
														const subjectCountsMap = new Map(this.props.subjectCounts.map(([subject_id, count]) => [subject_id, count]));
														filterItems = this.state.allSubjects?.map((val) => ({
															filter: "Subject",
															name: val.subject,
															subject_id: val.subject_id,
															dynamic_count: subjectCountsMap.get(val.subject_id) || 0,
														}));
													} else if (category === "Author") {
														const authorCountsMap = new Map(this.props.authorCounts.map(([author_id, count]) => [author_id, count]));
														filterItems = this.state.allAuthors?.map((val) => ({
															filter: "Author",
															name: val.author,
															author_id: val.author_id,
															dynamic_count: authorCountsMap.get(val.author_id) || 0,
														}));
													} else if (category === "Year") {
														const yearCountsMap = new Map(this.props.yearCounts.map(([year_id, count]) => [year_id, count]));
														filterItems = this.state.allYears?.map((val) => ({
															filter: "Year",
															name: val.year,
															year_id: val.year_id,
															dynamic_count: yearCountsMap.get(val.year_id) || 0,
														}));
													} else if (category === "Grade") {
														const gradeCountsMap = new Map(this.props.gradeCounts.map(([grade_id, count]) => [grade_id, count]));
														filterItems = this.state.allGrades?.map((val) => ({
															filter: "Grade",
															name: val.grade,
															grade_id: val.grade_id,
															dynamic_count: gradeCountsMap.get(val.grade_id) || 0,
														}));
													} else if (category === "Term") {
														const termCountsMap = new Map(this.props.termCounts.map(([term_id, count]) => [term_id, count]));
														filterItems = this.state.allTerms?.map((val) => ({
															filter: "Term",
															name: val.term,
															term_id: val.term_id,
															dynamic_count: termCountsMap.get(val.term_id) || 0,
														}));
													} else if (category === "Chapter") {
														const chapterCountsMap = new Map(this.props.chapterCounts.map(([chapter_id, count]) => [chapter_id, count]));
														filterItems = this.state.allChapters?.map((val) => ({
															filter: "Chapter",
															name: val.chapter,
															chapter_id: val.chapter_id,
															dynamic_count: chapterCountsMap.get(val.chapter_id) || 0,
														}));
													} else if (category === "Source") {
														const sourceCountsMap = new Map(this.props.sourceCounts.map(([source_id, count]) => [source_id, count]));
														filterItems = this.state.allSources?.map((val) => ({
															filter: "Source",
															name: val.source,
															source_id: val.source_id,
															dynamic_count: sourceCountsMap.get(val.source_id) || 0,
														}));
													} else if (category === "Created_By") {
														const createdByCountsMap = new Map(this.props.createdByCounts.map(([created_by_id, count]) => [created_by_id, count]));
														filterItems = this.state.allCreators?.map((val) => ({
															filter: "Created_By",
															name: val.first_name + " " + val.last_name,
															created_by_id: parseInt(val.created_by_id),
															dynamic_count: createdByCountsMap.get(parseInt(val.created_by_id)) || 0,
														}));
													}

													return (
														<div className="filterCard" key={index} style={{ display: "inline-block", minWidth: "300px", marginRight: "16px", maxHeight: "30vh" }}>
															<FormControlLabel
																label={category}

																sx={{
																	display: "flex",
																	alignItems: "center",
																	justifyContent: "flex-start",
																	"& .MuiFormControlLabel-label": { fontWeight: "600" },
																}}
																control={
																	<Checkbox
																		checked={this.isParentChecked(category)}
																		indeterminate={this.isParentIndeterminate(category)}
																		onChange={() => this.handleParentCheckboxChange(category, filterItems)}
																	/>
																}
															/>
															<Box sx={{ display: "flex", flexDirection: "column", ml: 3, maxHeight: "20vh", overflowY: "auto" }}>

																{filterItems?.map((item) => {

																	const isChecked = this.state.filterValues.some((selectedItem) =>
																		selectedItem.filter === item.filter &&
																		selectedItem[`${item.filter.toLowerCase()}_id`] === item[`${item.filter.toLowerCase()}_id`]
																	);

																	return (
																		<FormControlLabel
																			key={item[`${category.toLowerCase()}_id`]}
																			//label={`${item.name} ${` (${item.dynamic_count })`}`}
																			label={`${item.name} ${item.dynamic_count !== 0 ? ` (${item.dynamic_count})` : ""}`}
																			//disabled={item.dynamic_count === 0 || this.state.isTableDataLoading}
																			control={
																				<Checkbox
																					checked={isChecked}
																					onChange={() => this.onSelectFilterMulti(item)}
																				/>
																			}
																		/>
																	)
																})}
															</Box>
														</div>
													);
												})}
											</Box>
										</Accordion>
									</div>
								</div> 
								 <div className="col-md-15 mt-5">
													{this.state.filterValues && this.state.filterValues.length > 0 &&
														<PaperListChips
															filterValues={this.state.filterValues}
															chipClick={this.onSelectFilterMulti}
															clearAll={this.clearAllFilters}
														/>
													}
												</div> */}
									<div className="row align-items-center setup-assessment-toolbar">
										<div className="col-md-6 d-flex align-items-center setup-assessment-toolbar-left">
											<span className="badge badge-custom setup-assessment-question-count">
												No of Questions:{" "}
												<strong>
													{this.state.isTableDataLoading ? (
														<CircularProgress size={16} />
													) : (
														this.props.totalRealFilteredCount
													)}
												</strong>
											</span>

											{this.state.assessment_parts.length > 0 &&
												this.state.assessment["role_code"] === "CASS" && (
													<Button
														className="btn btn-primary setup-assessment-section-btn"
														btnName="Update Question Part/Section"
														btnIconStyle="flaticon-add"
														onClick={() => this.setState({ showAddQuestionsModal: true })}
														disabled={[
															"Ready",
															"Review",
															"InReview",
															"ReviewCompleted",
															"Published",
															"Retired",
														].includes(this.state.assessment.assessment_state)}
													/>
												)}

											<button
												type="button"
												className="setup-assessment-action-btn setup-assessment-toolbar-toggle-btn"
												onClick={this.toggleFilterPanelVisibility}
											>
												{this.state.isFilterPanelVisible ? (
													<>
														<ChevronLeftIcon fontSize="small" />
														<span>Hide Filters</span>
													</>
												) : (
													<>
														<ChevronRightIcon fontSize="small" />
														<span>Show Filters</span>
													</>
												)}
											</button>
										</div>

										<div className="col-md-6 d-flex justify-content-end align-items-center setup-assessment-toolbar-right">
											<ReactForm.Group controlId="exampleForm.ControlInput1" className="mb-0 me-3 setup-assessment-search-group">
												<ReactForm.Control
													type="text"
													placeholder="Search"
													onChange={this.handleSearch}
													className="w-100 setup-assessment-search-input"
												/>
											</ReactForm.Group>
											<div className="setup-assessment-total-marks" aria-label="total marks">
												<span className="setup-assessment-total-marks-label">Total Marks</span>
												<strong className="setup-assessment-total-marks-value">{this.state.total || 0}</strong>
											</div>
										</div>
									</div>


									{this.state.isFilterPanelVisible && (
										<div className="col-md-12 px-0 mb-3 staff-filters-wrapper">
											<div className="card">
												<PaperFilterLayout
													userType={"DEOP"}
													onFilterChange={this.handleFilterChange}
													filterKeys={EMPLOYEE_FILTERS.DEOP.SetupAssessment}
													isShowExamStatus={false}
													showFilterToggleButton={true}
													onToggleFilters={this.toggleFilterPanelVisibility}
												/>
											</div>
										</div>
									)}

									<div className="thepapers-wrapper">
										<div className="col-md-12 px-0">
											<div className="row">
												<div
													className="col-md-12 transition-width"
												>

													<TabContent>
														<TabPane className="tab-pane fade show active" id="questions-library-1"
															ariaLabelledby="questions-library-tab-1">
															{(this.state.isTableDataLoading) ? (
																<div>
																	<div className="loading-container mb-5 mt-10">
																		<ReactSpinner animation="border" role="status" style={{ display: 'block', margin: 'auto' }}>
																			<span className="sr-only">Loading...</span>
																		</ReactSpinner>
																	</div>
																</div>
															) : (
																this.synceTableSetupAssessment(this.state.assessmentQuestionsData)
															)
															}
															<div className="d-flex justify-content-end">
																<MaterialCustomTablePagination
																	totalCount={this.props.totalFilteredCount}
																	currentPage={this.state.currentPage}
																	limit={this.state.rowsPerPage}
																	handlePageChange={this.handlePageChange}
																	handleRowsPerPageChange={this.handleRowsPerPageChange}
																	handlePageOffsetChange={this.handlePageOffsetChange}
																	offset={this.state.offset}
																	rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 75, 100, 150, 200, 250, 300]}
																/>
															</div>
														</TabPane>
													</TabContent>

													{/* View Question Modal */}
													<SelfGradeModal modalId="view-details" dataBackDrop="static" dataKeyboard="false">
														<ModalHeader>
															<h4 className="modal-title text-muted">{this.props.libraryQuestion?.title}</h4>
															<Button className="btn btn-light-primary font-weight-bold" dataDismiss="modal" btnName="Close" />
														</ModalHeader>
														{this.state.isViewModalLoading ? (
															<div>
																<div className="loading-container mb-5 mt-10">
																	<ReactSpinner
																		animation="border"
																		role="status"
																		style={{ display: "block", margin: "auto" }}
																	>
																		<span className="sr-only">Loading...</span>
																	</ReactSpinner>
																</div>
															</div>
														) : (
															<ModalBody>
																<div className="pb-5" data-wizard-type="step-content" data-wizard-state="current">
																	{/* begin::Section */}
																	{this.state.editPassageContentState?.getCurrentContent?.().hasText() && (
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-md-3">Passage :</h6>
																			<div className="text-dark-50 line-height-lg col-md-9">
																				<div>
																					<ViewEditor editorState={this.state.editPassageContentState} />
																				</div>
																				<div className="separator separator-dashed my-5" />
																			</div>
																		</div>
																	)}
																	<div className="row">
																		<h6 className="font-weight-bolder mb-3 col-md-3">Question</h6>
																		<div className="text-dark-50 line-height-lg col-md-9">
																			<div>
																				<ViewEditor
																					editorState={this.state.editorQuestionState}
																				/>
																			</div>
																		</div>
																	</div>

																	<div className="separator separator-dashed my-5" />
																	{/* end::Section */}
																	{/* begin::Section */}
																	{this.props.libraryQuestion?.sub_questions === null && (
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-lg-3 col-md-12">Model Answer</h6>
																			<div className="text-dark-50 line-height-lg col-lg-9 col-md-12">
																				<div>
																					{this.props.libraryQuestion?.question_type === questionTypeConstants.DESCRIPTIVE.name && this.props?.libraryAnswerContent &&
																						<div>
																							<ViewEditor
																								editorState={this.state.editorAnswerStateDescriptive}
																							/>
																						</div>

																					}
																					{this.props.libraryQuestion?.question_type === questionTypeConstants.SUBQUESTION.name && this.props?.libraryAnswerContent && this.props.libraryQuestion?.is_subquestion === "true" &&
																						<div>
																							<ViewEditor
																								editorState={this.state.editorAnswerStateDescriptive}
																							/>
																						</div>

																					}
																					{this.props.libraryQuestion?.question_type === questionTypeConstants.MCQ.name && this.props?.libraryQuestionContent &&
																						<div>

																							{this.state.editorAnswerStates?.length > 0 &&
																								this.state.editorAnswerStates?.map((editorState, i) => (
																									<div className="view-questions-answer d-flex">


																										{this.props.libraryQuestion?.answer_type_id === questionMCQAnswerTypeConstants.One.id ?
																											<RadioInline className="col-md-1">
																												<Radio checked={this.state.selectedChoices[i]} />
																											</RadioInline>
																											:
																											<CheckBoxInline className="col-md-1">
																												<CheckBox checked={this.state.selectedChoices[i]} />
																											</CheckBoxInline>
																										}
																										<div className="RichEditor-root">
																											<ViewEditor
																												editorState={this.state.editorAnswerStates[i]}
																											/>
																										</div>
																									</div>
																								))
																							}
																						</div>
																					}
																					{this.props.libraryQuestion?.question_type === questionTypeConstants.SUBMISSION.name && this.state.attachment &&
																						<div className="RichEditor-root col-lg-8">
																							{this.state.attachment.map(attach => {
																								if (attach.replace(/"/g, '') != "[]") {
																									return <div>
																										<Button className="btn btn-outline-primary primary-button mr-2" btnIconStyle="flaticon-interface-3" inlineStyle={{ innerWidth: '400px' }}
																											btnName={attach.replace(/"/g, '')} onClick={(e) => {
																												this.onDownloadAttachment(e, attach.replace(/"/g, ''))
																											}} />
																										<br></br></div>
																								}
																								else {
																									return <div>
																									</div>
																								}
																							})
																							}
																						</div>
																					}
																				</div>
																			</div>
																		</div>
																	)}
																</div>

																{this.props?.libraryQuestion?.category_id && (
																	<>
																		<div className="separator separator-dashed my-5"></div>
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-md-4">
																				Category :
																			</h6>
																			<div className="text-dark-50 line-height-lg col-md-5">
																				<div className="inline-flex full-width align-center">
																					{
																						this.props?.allQuestionMetaData.find(item => 'categories' in item).categories
																							.find(category => category.category_id === this.props?.libraryQuestion?.category_id)?.name
																					}
																				</div>
																			</div>
																		</div>
																	</>
																)}

																{this.props?.libraryQuestion?.qtype && (
																	<>
																		<div className="separator separator-dashed my-5"></div>
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-md-4">
																				Type :
																			</h6>
																			<div className="text-dark-50 line-height-lg col-md-5">
																				<div className="inline-flex full-width align-center">
																					{
																						this.props?.allQuestionMetaData.find(item => 'types' in item).types
																							.find(type => type.type_id === this.props?.libraryQuestion?.qtype)?.qtype
																					}
																				</div>
																			</div>
																		</div>
																	</>
																)}

																{this.props?.libraryQuestion?.language_id && (
																	<>
																		<div className="separator separator-dashed my-5"></div>
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-md-4">
																				Language :
																			</h6>
																			<div className="text-dark-50 line-height-lg col-md-5">
																				<div className="inline-flex full-width align-center">
																					{
																						this.props?.allQuestionMetaData.find(item => 'languages' in item).languages
																							.find(language => language.language_id === this.props?.libraryQuestion?.language_id)?.language
																					}
																				</div>
																			</div>
																		</div>
																	</>
																)}

																{this.props?.libraryQuestion?.difficulty_id && (
																	<>
																		<div className="separator separator-dashed my-5"></div>
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-md-4">
																				Difficulty :
																			</h6>
																			<div className="text-dark-50 line-height-lg col-md-5">
																				<div className="inline-flex full-width align-center">
																					{
																						this.props?.allQuestionMetaData.find(item => 'difficulty_types' in item).difficulty_types
																							.find(difficulty => difficulty.difficulty_id === this.props?.libraryQuestion?.difficulty_id)?.difficulty_type
																					}
																				</div>
																			</div>
																		</div>
																	</>
																)}

																{this.props?.libraryQuestion?.grade_id && (
																	<>
																		<div className="separator separator-dashed my-5"></div>
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-md-4">
																				{gradeText} :
																			</h6>
																			<div className="text-dark-50 line-height-lg col-md-5">
																				<div className="inline-flex full-width align-center">
																					{
																						this.props?.allQuestionMetaData.find(item => 'grades' in item).grades
																							.find(grade => grade.grade_id === this.props?.libraryQuestion?.grade_id)?.grade
																					}
																				</div>
																			</div>
																		</div>
																	</>
																)}

																{this.props?.libraryQuestion?.subject_id && (
																	<>
																		<div className="separator separator-dashed my-5"></div>
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-md-4">
																				Subject :
																			</h6>
																			<div className="text-dark-50 line-height-lg col-md-5">
																				<div className="inline-flex full-width align-center">
																					{
																						this.props.allQuestionMetaData.find(item => 'subjects' in item).subjects
																							.find(subject => subject.subject_id === this.props?.libraryQuestion?.subject_id)?.subject
																					}
																				</div>
																			</div>
																		</div>
																	</>
																)}

																{this.props?.libraryQuestion?.year_id && !isCMC && (
																	<>
																		<div className="separator separator-dashed my-5"></div>
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-md-4">
																				Year :
																			</h6>
																			<div className="text-dark-50 line-height-lg col-md-5">
																				<div className="inline-flex full-width align-center">
																					{
																						this.props?.allQuestionMetaData.find(item => 'years' in item).years
																							.find(year => year.year_id === this.props?.libraryQuestion?.year_id)?.year
																					}
																				</div>
																			</div>
																		</div>
																	</>
																)}

																{this.props?.libraryQuestion?.term_id && (
																	<>
																		<div className="separator separator-dashed my-5"></div>
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-md-4">
																				Term/Semester :
																			</h6>
																			<div className="text-dark-50 line-height-lg col-md-5">
																				<div className="inline-flex full-width align-center">
																					{
																						this.props?.allQuestionMetaData.find(item => 'terms' in item).terms
																							.find(term => term.term_id === this.props?.libraryQuestion?.term_id)?.term
																					}
																				</div>
																			</div>
																		</div>
																	</>
																)}

																{this.props?.libraryQuestion?.chapter_id && (
																	<>
																		<div className="separator separator-dashed my-5"></div>
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-md-4">
																				Chapter/Module/Unit :
																			</h6>
																			<div className="text-dark-50 line-height-lg col-md-5">
																				<div className="inline-flex full-width align-center">
																					{
																						this.props?.allQuestionMetaData.find(item => 'chapters' in item).chapters
																							.find(chapter => chapter.chapter_id === this.props?.libraryQuestion?.chapter_id)?.chapter
																					}
																				</div>
																			</div>
																		</div>
																	</>
																)}

																{this.props?.libraryQuestion?.source_id && (
																	<>
																		<div className="separator separator-dashed my-5"></div>
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-md-4">
																				Source :
																			</h6>
																			<div className="text-dark-50 line-height-lg col-md-5">
																				<div className="inline-flex full-width align-center">
																					{
																						this.props?.allQuestionMetaData.find(item => 'sources' in item).sources
																							.find(source => source.source_id === this.props?.libraryQuestion?.source_id)?.source
																					}
																				</div>
																			</div>
																		</div>
																	</>
																)}

																{this.props?.libraryQuestion?.author_id && (
																	<>
																		<div className="separator separator-dashed my-5"></div>
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-md-4">
																				Author :
																			</h6>
																			<div className="text-dark-50 line-height-lg col-md-5">
																				<div className="inline-flex full-width align-center">
																					{
																						this.props?.allQuestionMetaData.find(item => 'authors' in item).authors
																							.find(author => author.author_id === this.props?.libraryQuestion?.author_id)?.author
																					}
																				</div>
																			</div>
																		</div>
																	</>
																)}

																{this?.props?.libraryQuestion?.first_name && this?.props?.libraryQuestion?.last_name && (
																	<>
																		<div className="separator separator-dashed my-5"></div>
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-md-4">
																				Created By :
																			</h6>
																			<div className="text-dark-50 line-height-lg col-md-5">
																				<div className="inline-flex full-width align-center">
																					{
																						this?.props?.libraryQuestion?.first_name + " " + this?.props?.libraryQuestion?.last_name
																					}
																				</div>
																			</div>
																		</div>
																	</>
																)}

																{this?.props?.libraryQuestion?.created_at && (
																	<>
																		<div className="separator separator-dashed my-5"></div>
																		<div className="row">
																			<h6 className="font-weight-bolder mb-3 col-md-4">
																				Created At :
																			</h6>
																			<div className="text-dark-50 line-height-lg col-md-5">
																				<div className="inline-flex full-width align-center">
																					{
																						this.getCreatedAtLocal(this?.props?.libraryQuestion?.created_at)
																					}
																				</div>
																			</div>
																		</div>
																	</>
																)}
															</ModalBody>
														)}
													</SelfGradeModal>
												</div>
											</div>
										</div>
									</div>
								</CardBody>
							</Card>
						) : (
							<Card>
								<div>
									<div className="loading-container mb-5 mt-10" style={{ height: "90vh" }}>
										<ReactSpinner animation="border" role="status" style={{ display: 'block', margin: 'auto' }}>
											<span className="sr-only">Loading...</span>
										</ReactSpinner>
									</div>
								</div>
							</Card>
						)}
						{/* end::Card */}
						<Snackbar
							open={this.state.snackbar.open}
							autoHideDuration={4000}
							onClose={this.handleCloseSnackbar}
							anchorOrigin={{ vertical: "top", horizontal: 'right' }}
						>
							<Alert
								onClose={this.handleCloseSnackbar}
								severity={this.state.snackbar.severity}
								variant="filled"
								sx={{ width: '100%' }}
							>
								{this.state.snackbar.message}
							</Alert>
						</Snackbar>

						<AddQuestionPartSection
							open={this.state.showAddQuestionsModal}
							onClose={() => this.setState({ showAddQuestionsModal: false })}
							assessment_parts={this.state.assessment_parts}
							assessment_sections={this.state.assessment_sections}
							assessmentFilteredQuestions={this.props.assessmentFilteredQuestions}
							selectedAssessmentId={this.state.selectedAssessmentId}
							addPartSectionLoading={this.state.addPartSectionLoading}
							onSuccess={this.fetchAllAssessmentQuestions}
							containerName={config.storageBlobConfigs.containerName}
						/>
					</div>
				</ContentWrapper>
			</AdminTemplate>
		)
	}
}

function mapStateToProps(state) {
	return {
		allTeachers: state.manageUserReducer.allTeachers,
		teacher: state.manageUserReducer.teacher,
		staffUserRoleMap: state.staffUserReducer.staffUserRoleMap,
		staffUserMap: state.staffUserReducer.staffUserMap,
		allStaffUsers: state.staffUserReducer.allStaffUsers,
		assessment: state.questionReducer.assessment,
		question: state.questionReducer.question,
		libraryQuestion: state.questionsLibraryReducer.question,
		questionContent: state.questionReducer.questionContent,
		libraryQuestionContent: state.questionsLibraryReducer.questionContent,
		libraryAnswerContent: state.questionsLibraryReducer.answerContent,
		questionContents: state.questionReducer.questionContents,
		questionContentsByType: state.questionReducer.questionContentsByType,
		questions: state.questionReducer.questions,
		assessmentQuestions: state.questionReducer.assessmentQuestions,
		assessmentFilteredQuestions: state.questionReducer.assessmentFilteredQuestions,
		totalFilteredCount: state.questionReducer.totalAssessmentFilteredQuestionsCount,
		totalRealFilteredCount: state.questionReducer.totalRealAssessmentFilteredQuestionsCount,
		gradeCounts: state.questionReducer.gradeCounts,
		subjectCounts: state.questionReducer.subjectCounts,
		languageCounts: state.questionReducer.languageCounts,
		authorCounts: state.questionReducer.authorCounts,
		categoryCounts: state.questionReducer.categoryCounts,
		difficultyCounts: state.questionReducer.difficultyCounts,
		chapterCounts: state.questionReducer.chapterCounts,
		yearCounts: state.questionReducer.yearCounts,
		termCounts: state.questionReducer.termCounts,
		typeCounts: state.questionReducer.typeCounts,
		sourceCounts: state.questionReducer.sourceCounts,
		createdByCounts: state.questionReducer.createdByCounts,
		sections: state.questionReducer.sections,
		assessment_details: state.questionReducer.assessment_details,
		teachers: state.questionReducer.teachers,
		loading: state.questionReducer.loading,
		finalizeSuccess: state.assessmentReducer.success,
		finalizeError: state.assessmentReducer.error,
		updateSuccess: state.questionReducer.success,
		updateError: state.questionReducer.error,
		allQuestionMetaData: state.questionsCreateReducer.allQuestionMetaData,
	};
}

const mapActionsToProps = {
	createStaffUserMap: staffUserActions.createStaffUserMap,
	refreshPage: questionActions.refreshPage,
	viewAddQuestions: questionActions.viewAddQuestions,
	getStaffUsers: staffUserActions.getAllStaffUsers,
	getAllTeachers: manageUserActions.getAllTeachers,
	getAllQuestions: questionActions.getAllQuestions,
	getAllLibraryQuestions: libraryActions.getAllQuestions,
	getQuestionContent: questionActions.getQuestionContent,
	getLibraryQuestionContent: libraryActions.getQuestionContent,
	getLibraryAnswerContent: libraryActions.getAnswerContent,
	refreshforAddingQuestions: questionActions.refreshforAddingQuestions,
	getAssessmentQuestions: questionActions.getAssessmentQuestions,
	getAllAssessmentQuestions: questionActions.getAllAssessmentQuestions,
	getAllQuestionContentsByType: questionActions.getAllQuestionContentsByType,
	getAllQuestionContents: questionActions.getAllQuestionContents,
	removeMyQuestions: questionActions.removeMyQuestions,
	saveUpdates: questionActions.saveUpdates,
	finalizeAssessment: assessmentActions.finalizeAssessment,
	applyPositionChangeLocal: questionActions.applyPositionChangeLocal,
	getQuestionMetaData: questionCreateActions.getQuestionMetaData,
	getTeacherMe: manageUserActions.getTeacherMe,
};

export default connect(mapStateToProps, mapActionsToProps)(Finalize);
